export default {
  auth: {
    unauthenticated: 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.'
  },
  acl: {
    load_error: 'Fehler beim Laden der ACL.'
  },
  headMenue: {
    customer: 'Kunde',
    fmv: 'FMV',
    courses: 'Kurse',
    ls: 'Akademie',
    kifam: 'Familie',
    schedtools: 'Planungstool',
    tickets: 'Ticket',
    campaigns: 'Kampagnen',
    search: 'Suche',
  },
  tabs: {
    course_basic_data: 'Kursbezeichnung',
    course_general_data: 'Allgemeine Einstellungen',
    course_participation: 'Kursteilnahme',
    course_information: 'Kursinformation',
    service_contribution: 'Dienstl./Beitrag',
    course_master_data: 'Stammdaten',
    course_dates: 'Termine',
    lecturer_days: 'Fachlehrkrafttage',
    teacher_days: 'Kurstage',
    subscriber: 'Teilnehmer',
    course_documents: 'Kursunterlagen',
    invoice: 'Abrechnung',
    benefits: 'Leistungen',
    person: 'Person',
    company: 'Firma',
    contact: 'Kontakt',
    documents: 'Dokumente',
    action: 'Aktion',
  },
  contact: {
    in_title: 'Kontakt IN',
    out_title: 'Kontakt OUT',
    campaign_title: 'Aktion Kampagne',
    ticket_history_title: 'Kontakthistorie Tickets',
    medium: 'Medium',
    subject: 'Thema',
    result: 'Ergebnis',
    campaign_status: 'Kampagnenstatus',
    campaign: 'Kampagne',
    message: 'Nachricht',
    to: 'an',
    request: 'Wunsch',
    status: 'Status'
  },
  relations: {
    title: 'Kundenbeziehung',
    start: 'Beginn',
    purpose: 'Verwendung',
    payment_method: 'Zahlung',
    payment_status: 'Bez. Status',
    customer_number: 'KundenNr.',
    phone: 'Tel.',
    letter: 'Brief'
  },
  payments: {
    title: 'Beitragshistorie',
    title_participant: 'Teilnehmerbeitragshistorie',
    relation: 'verknüpfte Beziehung',
    purpose: 'Verwendungszweck',
    notice: 'Notiz',
    maturity: 'Fälligkeit',
    status: 'Bezahl Status'
  },
  documents: {
    title: 'Dokumentenliste',
    name: 'Dokumentenname',
    invoice: 'Rechnung',
    kind: 'Art',
    kind_values: {
      certific: 'Zertifikat',
      fa_sammel: 'FA-Sammelrechnung',
      ausfall: 'Ausfallrechnung',
      bg_sammel: 'BG-Sammelrechnung',
      frei_rg: 'Freie Rechnung'
    },
    time: 'Zeit',
    size: 'Größe',
    upload_title: 'Dokument hochladen',
    upload_button: 'Hochladen',
    upload_file: 'Datei auswählen',
    upload_types: 'Erlaubte Formate: {types}',
    upload_max_size: 'Maximale Größe: {size}',
    upload_error_client: 'Bitte zuerst einen Kunden auswählen.',
    upload_error_file: 'Bitte eine Datei auswählen.',
    upload_error_size: 'Die Datei ist zu groß (max. {size}).',
    upload_error_type: 'Dateityp nicht erlaubt. Erlaubt: {types}.',
    upload_error_generic: 'Datei konnte nicht hochgeladen werden.',
    download_error_title: 'Download fehlgeschlagen',
    download_error_generic: 'Datei konnte nicht heruntergeladen werden.',
    delete_confirm: 'wirklich löschen'
  },
  paginator: {
    site: 'pro Seite',
    from: 'von'
  },
  table: {
    no_data: 'Keine Daten verfügbar',
    columns: 'Spalten',
    info: 'Info',
    select_columns: 'Spalten auswählen',
    selected_one: '1 Datensatz ausgewählt.',
    selected_many: '{count} Datensätze ausgewählt.'
  },
  common: {
    validationErrors: 'Bitte die markierten Felder prüfen.',
    processing: 'Wird verarbeitet …',
    from: 'von',
    none: 'keine',
    show: 'Anzeigen',
    email: 'eMail',
    description: 'Bezeichnung',
    amount: 'Zahlbetrag',
    date: 'Datum',
    service: 'Dienstleistung',
    last_change: 'letzte Änderung',
    billing: 'Abrechnung',
    payment_method: 'Zahlungsform',
    name: 'Name',
    website: 'Website',
    phone: 'Telefon',
    course_type: 'Kurstyp',
    appointment: 'Termin',
    search: 'Suche',
    duplicate_check: 'Dublettenabgleich',
    employee: 'Mitarbeiter',
    link: 'Link',
    noResults: 'Keine Optionen',
    saved: 'Gespeichert',
    deleted: 'Erfolgreich gelöscht',
    error: 'Fehler',
    back: 'Zurück'
  },
  loginPage: {
    dbUnavailableTitle: 'Datenbankverbindung nicht verfügbar',
    dbUnavailableMessage: 'Die Verbindung zur Datenbank kann derzeit nicht hergestellt werden. Bitte versuchen Sie es in Kürze erneut.',
    retry: 'Erneut versuchen'
  },
  cliSampleDemo: {
    routeTitle: 'Queue/Mercure Demo',
    title: 'Queue-, CLI- und Mercure-Demo',
    description: 'Startet einen 30-Sekunden-Timer als CLI-Command über die Queue und aktualisiert den Laufstatus per Mercure.',
    startButton: 'Demo starten',
    routeHint: 'Aufrufbar über /main/queue-mercure-sample',
    idleStatus: 'nicht gestartet',
    progressLabel: 'Fortschritt',
    progressText: '{elapsed} von {seconds} Sekunden erledigt ({progress}%)',
    eventsTitle: 'Ereignisse',
    noEvents: 'Noch keine Ereignisse empfangen.',
    startError: 'Demo konnte nicht gestartet werden.',
    fields: {
      runId: 'Run-ID',
      status: 'Status',
      source: 'Quelle',
      topic: 'Mercure-Topic'
    },
    genericTriggerLabel: 'Generischer Task-Trigger (Demo)'
  },
  organisationSettings: {
    title: 'Vereinsdaten',
    module_hint: 'Anzeige für Modul: {module}',
    module_select: 'Modul',
    membernumber_status: {
      active: 'Aktiv',
      inactive: 'Deaktiv'
    },
    modules: {
      kdb: 'Kunden',
      fmv: 'Mitglieder',
      ktv: 'Kurse',
      kifam: 'Familie',
      ls: 'Akademie',
      av: 'Aktiven'
    },
    cards: {
      central: 'Zentrale Einstellungen',
      module: 'für das Modul',
      organisation: 'Vereinsdaten',
      bank: 'Bank {number}',
      letterhead: 'Briefkopf- und Formulardaten',
      sepa: 'SEPA',
      barcode: 'Barcodenummer',
      member_number: 'Nummernkreis',
      annual_receipts: 'Jahresquittungen',
      flight_service: 'Flugdienst',
      course_billing: 'Abrechnung und Nummernkreis',
      export_interface: 'Export Schnittstelle',
      vbg: 'VBG - Anmeldung',
      bg_rate: 'BG-Satz',
      drk_server: 'DRK-Server Anmeldung',
      ortsvereine: 'Ortsvereine',
      marketing_groups: 'Marketinggruppen',
      newspaper: 'Zeitungstitel'
    },
    barcode: {
      dialog_title: 'Barcodenummer bearbeiten',
      selection: 'Auswahl',
      format: 'Barcodeformat',
      variables: {
        year: 'Jahr <jahr> ({example})',
        date: 'Datum <datum> ({example})',
        timestamp: 'Zeitstempel <zeitstempel>',
        client_id: 'Client-ID <kunden_id>',
        counter: 'Barcode-Zähler <counter> ({example})'
      },
      notice: 'Bei jeder Rechnungserstellung wird der Barcode mit den definierten Variablen erzeugt. Er wird mit der individuellen Rechnungserstellung fixiert und kann nicht nachträglich verändert werden.',
      validation_characters: 'Unterstützt werden A–Z, Zahlen, Leerzeichen, -.$/+% und die angebotenen Variablen.',
      validation_max_length: 'Das Barcodeformat darf höchstens 255 Zeichen lang sein.',
      saved: 'Barcodenummer wurde gespeichert.',
      save_error: 'Barcodenummer konnte nicht gespeichert werden.'
    },
    lists: {
      title_label: 'Titel',
      description_label: 'Beschreibung',
      no_data: 'Keine Einträge vorhanden',
      default_hint: 'Standardeinträge (kursiv) können nicht bearbeitet oder gelöscht werden.',
      validation_required: 'Pflichtfeld',
      validation_max_length: 'Maximal 255 Zeichen',
      saved: 'Erfolgreich gespeichert',
      deleted: 'Erfolgreich gelöscht',
      save_error: 'Fehler beim Speichern',
      delete_error: 'Fehler beim Löschen',
      load_error: 'Einträge konnten nicht geladen werden',
      module_label: 'Modul',
      module_all: 'alle'
    },
    help: {
      main_bank: 'Aktiv bedeutet: Bank 2 ist die Hauptbank. Inaktiv bedeutet: Bank 1 ist die Hauptbank.',
      invoices_entrepreneur: 'Gemäß § 14 Abs. 4 UStG muss auf Rechnungen der vollständige Name des Unternehmers angegeben werden.',
      person_1_title: 'Briefvariable: VD_Person_1_Title',
      person_1_name: 'Briefvariable: VD_Person_1_Name',
      person_2_title: 'Briefvariable: VD_Person_2_Title',
      person_2_name: 'Briefvariable: VD_Person_2_Name',
      check_paypal_invoice: 'Automatische Rechnungserzeugung der Paypalzahlung ins Rechnungsjournal\n\nWurde der Kursbetrag per Paypal bezahlt und der Teilnehmer durch die Onlineanmeldung übernommen, wird im Rechnungsjournal automatisch eine Rechnung im Bereich "Gebuchte Rechnungen" hinzugefügt.',
      membernumber_check: 'Mitgliedsnummergenerierung\n\nDer Präfix ist ein fixer Wert, die dahinterliegende\nNummer wird automatisch (+1) hoch gezählt.\n\nJede Mitgliederbeziehung bei der das Feld Mitgliedsnummer leer bleibt, erhält autom. eine neue Nummer.\n\nBsp.: "477" "000001"\nNeue Mitgl.Nr.: 477000002, 477000003, 477000004 etc.\n\nWird bei einem Kunden manuell eine höhere Nummer hinzugefügt, wird immer die höchste Nummer als Referenzwert genommen.\n\nBsp.: 5999999999 nächste 6000000000\n\nNach Aktivierung können Änderungen nur noch durch DDL erfolgen!',
      flight_operations: 'Erst wenn die Jahressumme der Mitgliedschaft erreicht wurde, steht die Auswahl vom Flugdienst bereit.',
      flight_current_cost: 'Der neue Tarif wird verwendet, wenn ein Betrag eingetragen ist und im Feld "ab Jahr" das Jahr ausgewählt wurde.',
      flight_year: 'Das Feld "ab Jahr" legt fest, ab wann der neue Tarif gilt.',
      flight_operations_cost: 'Der alte Tarif wird so lange verwendet, bis ein Betrag im Feld "neuer Tarif" in Verbindung mit dem Feld "ab Jahr" eingetragen wurde.'
    },
    headings: {
      invoices_entrepreneur: 'Für Rechnungen: Name des Unternehmers gemäß § 14 Abs. 4 USTG:',
      invoice_number_range: 'Rechnungsnummer',
      export_interface: 'Export Schnittstelle'
    },
    iban_invalid: 'Ungültige IBAN',
    iban_calculate_error: 'BLZ und Kontonummer ergeben keine gültige IBAN',
    fields: {
      name: 'Name',
      street: 'Straße',
      zipcode: 'PLZ',
      city: 'Stadt',
      phone: 'Telefon',
      fax: 'Fax',
      email: 'E-Mail',
      webpage: 'Webseite',
      level: 'Ebene KV, LV, ..',
      bank_name: 'Bankname',
      account_holder: 'Kto. Inh.',
      account_number: 'Kto. Nr.',
      bank_code: 'BLZ',
      iban: 'IBAN',
      bic: 'BIC',
      purpose_prefix: 'Verwendungszweck-Präfix',
      main_bank: 'Hauptbank',
      bank_1: 'Bank 1',
      bank_2: 'Bank 2',
      person_1_title: 'Person 1 Titel',
      person_1_name: 'Person 1 Name',
      person_2_title: 'Person 2 Titel',
      person_2_name: 'Person 2 Name',
      sales_tax: 'Umsatzsteuer ID',
      club_register: 'Vereinsregister',
      district: 'Kreis',
      land: 'Land',
      district_court: 'Amtsgericht',
      tax_office: 'Finanzamt',
      tax_number: 'Steuer-Nr.',
      responsible_doctor: 'verantw. Arzt',
      distance_price: 'Kilometersatz',
      creditor_id: 'Gläubiger ID',
      membernumber_prefix: 'Mitgliedsnummer Präfix',
      membernumber_from: 'Mitgliedsnummer Start',
      membernumber_check: 'Automatisch aktiv',
      years_of_receipt: 'Min. JQ Privatperson',
      years_of_receipt_firm: 'Min. JQ Unternehmen',
      flight_operations: 'Min. FLD-Summe',
      flight_operations_cost: 'alter Tarif',
      flight_current_cost: 'neuer Tarif',
      flight_year: 'ab Jahr',
      coursenumber_from: 'Kursnummer Start',
      account_tn_type: 'TN-Rechnung',
      account_dz_type: 'Dozenten Abr.',
      letter_invoice_prefix: 'Rechnungsnummer Präfix',
      letter_invoice_from: 'Rechnungsnummer Start',
      check_paypal_invoice: 'autom. Paypal-Rng',
      bg_rate_current_year: 'aktuelles Jahr',
      bg_rate_next_year: 'nächstes Jahr',
      vbg_idnumber: 'VBG Mitgliedsnummer',
      vbg_username: 'VBG Benutzer',
      vbg_password: 'VBG Passwort',
      drkserver_username: 'DRK-Server Benutzer',
      drkserver_password: 'DRK-Server Passwort',
      drkserver_org_id: 'DRK-Server Organisations-ID',
      drkserver_org_name: 'DRK-Server Organisation'
    },
    messages: {
      saved: 'Vereinsdaten wurden gespeichert.',
      load_error: 'Vereinsdaten konnten nicht geladen werden.',
      save_error: 'Vereinsdaten konnten nicht gespeichert werden.'
    }
  },
  interfaceSettings: {
    title: 'Schnittstellen',
    cards: {
      details: '{interface} Einstellungen'
    },
    actions: {
      save: 'Speichern'
    },
    radios: {
      tn: 'TN-Rechnung',
      dz: 'Dozenten Abr.'
    },
    interfaces: {
      entire: 'Entire',
      wilkenp5: 'WilkenP5',
      diamant: 'Diamant',
      sage: 'Sage',
      datev: 'Datev',
      navision: 'Navision',
      swing: 'Swing',
      excel: 'Excel',
      fibunet: 'Fibunet',
      micos: 'Micos',
      simba: 'Simba',
      addison: 'Addison (Beta)',
      sap: 'SAP',
      winline: 'WinLine',
      egecko: 'eGecko',
      fs: 'FS',
      scopevisio: 'Scopevisio',
      sage_hersfeld: 'Sage Hersfeld'
    },
    sections: {
      datev_column_labels: 'Spaltenbeschriftung',
      datev_ddl_standard: 'DDL-Standard'
    },
    options: {
      none: 'keine',
      prefixed_00: 'vorangest. 00',
      course_number: 'Kursnummer',
      invoice_number: 'Rechnungsnummer',
      manual: 'manuell',
      bookings: 'Buchungen',
      debtors_and_bookings: 'Debitoren und Buchungen',
      standard: 'Standard',
      standard_ii: 'Standard II',
      sz_fa: 'Selbstzahler/Firma',
      all: 'alle',
      cost_center: 'Kostenstelle',
      name: 'Name',
      name_street: 'Name und Straße',
      bookings_only: 'nur Buchungsdaten',
      datev_ddl_standard: 'DDL-Standard',
      datev_kv_emmendingen: 'KV Emmendingen',
      datev_kv_schwerin: 'KV Schwerin',
      datev_kv_solingen: 'KV Solingen',
      datev_kv_wolfach: 'KV Wolfach',
      datev_standard_ii: 'Datev-Standard II',
      datev_hochtaunus: 'Hochtaunus',
      datev_kv_muelheim: 'KV Mülheim a.d. Ruhr',
      yes: 'Ja',
      no: 'Nein',
      belegfeld2_sofort: 'Sofort',
      belegfeld2_auto_sz_bg: 'autom. 14 Tage(SZ), 30 Tage(BG)',
      belegfeld2_skonto_14_30: '14 Tage 2% Skonto 30 Tage netto ohne Abzug',
      belegfeld2_manual: 'manueller Eintrag',
      invoice_fields_34: 'Rechn-Nr. Felder (3,4)',
      datev_buchtxt_auto: 'autom. Text Kursnr. / Kursname / (von-bis)',
      datev_buchtxt_participant: 'Teilnehmer (Vor-, Nachname oder Firma)',
      datev_buchtxt_recipient: 'Rechnungsempf., Kurs-Nr., TN-Anzahl',
      four: '4',
      five: '5',
      six: '6',
      datev_kost2_no: 'Nein (leer)',
      datev_kost2_yes: 'Ja (Kostenstelle aus Kursgrundeinst.)'
    },
    fields: {
      export_type: 'Format',
      active: 'Aktiv',
      account_tn_type: 'TN-Rechnung',
      account_dz_type: 'Dozenten Abr.',
      mandant_id: 'Mandant-Id',
      mandant: 'Mandant',
      deb_beginn_option: 'Auswahl Vorangest. DebNr.',
      deb_beginn: 'Exportformat Vorangest. DebNr.',
      deb_sz: 'Dummy Deb.-Nr. Selbstzahler',
      rgn_nr_beginn: 'Rechnungsnr. beginnt mit',
      rgn_date: 'Barzahler Buchungsdatum',
      mitbuchkto: 'Mitbuchkonto',
      erloeskonto: 'Erlöskonto',
      kostenstelle: 'Kostenstelle',
      mahnstrg: 'Mahnstrategie',
      zahlungsbed_bg: 'Zahlungsbedingungen (BG)',
      zahlungsbed_sz_fa: 'Zahlungsbed. (Firma, Selbstz.)',
      buchtxt_option: 'Auswahl Buchungstext',
      buchtxt: 'Buchungstext',
      buch_datum: 'Buchungsdatum',
      rng_nr_current: 'Rechnungsnummer',
      rng_to_nr_msg: 'max. Rechnungsnummer',
      rng_to_nr_pre_msg: 'Hinweis vor max. Rechnungsnummer',
      deb_nr_current: 'Debitorennummer',
      deb_to_nr_msg: 'max. Debitorennummer',
      deb_to_nr_pre_msg: 'Hinweis vor max. Debitorennummer',
      buch_nav_exp: 'Auswahl Exportformat',
      buch_dat_exp: 'Auswahl Exportformat',
      expfeld1: 'Exportfeld 1',
      expfeld2: 'Exportfeld 2',
      expfeld3: 'Exportfeld 3',
      expfeld4: 'Exportfeld 4',
      sz_out: 'Selbstzahler ausschließen',
      belegfeld2_mode: 'Belegfeld 2 Optionen',
      belegfeld2: 'Belegfeld 2 manueller Eintrag',
      batch_booking: 'Stapelbuchung',
      extf_activ_debitoren: 'Stapelb. + Debitoren',
      consultant_number: 'Beraternummer',
      mandant_number: 'Mandantennummer',
      datev_belegnummer: 'Belegnummer',
      deb_only_scope: 'Debitoren-Nr. für',
      deb_only_sz_fa: 'Debitoren-Nr.',
      recipient_in_invoice: 'Empfänger in Buchungen',
      buchtxt_max_len: 'Buchungstext-Länge',
      gs_and_rng: 'Gutschrift mit verkn. Rechnung',
      extf_b_leistungsdatum: 'Leistungsdatum',
      extf_i_sachkontenlaenge: 'Sachkontenlänge',
      content_kost1: 'Inhalt von Kostenst.1',
      bool_kost2: 'Kostenst.2 aus Kursgrundeinst.',
      extf_bez_umsatz: 'Umsatz',
      extf_bez_sollhaben: 'Soll/Haben',
      extf_bez_wkzumsatz: 'WKZ Ums.',
      extf_bez_konto: 'Konto',
      extf_bez_gegenkonto: 'Gegenkto',
      extf_bez_buschluessel: 'BU-Schl.',
      extf_bez_kostenst1: 'Kostenst.1',
      extf_bez_leistungsdatum: 'Leist.dat.',
      firmennummer: 'Firmennummer',
      booking_period: 'Buchungsperiode',
      rgn_to_belegnr: 'Rechnungsnr. als Belegnr.',
      zusatzfeld_in_buchungstext: 'OP_Zusatzfeld in Buchungstext',
      k_ks_kursnr: '(K)-> Kostentr.= Kursnr.',
      projectdata_kursnr: '(K)->"Projekt" mit Kursnr.',
      renr_o_bindestr: 'Re.-Nr. ohne Bindestr.',
      kursnr_o_bindestr: 'Kursnr. ohne Bindestr.',
      mit_posten: '(G) Posten mit übergeben',
      with_masterdata: '(S) Stammdatensatz übergeben',
      diamant_split_export_files: 'Datei teilen (Deb./Buchung)',
      diamant_f_geschaeftskennzeichen: 'F (5) Geschäftskennz.',
      diamant_f_belegart: 'F (6) Belegart',
      diamant_g_steuerschluessel_aus_mwst: 'G (4) aus MwSt ableiten',
      diamant_g_steuersatz_leer: 'G (5) Steuersatz leer',
      diamant_s_bezeichnung_format: 'Adressdaten (6)',
      diamant_s_mahnart: 'S (14) Mahnart',
      diamant_s_zahlungskondition: 'S (16) Zahlkond.',
      diamant_s_konzernobjekt: 'S (63) Konzernobj.',
      diamant_v_barcode_quelle: 'V-Satz Barcode',
      belegart: 'Belegart',
      buchungskreis: 'Buchungskreis',
      deb_sz_general: 'SZ generelle DebNr.',
      bgfa_frist: 'Zahlungsfrist (FA oder BG)',
      sz_frist: 'Zahlungsfrist (Selbstzahler)',
      firma_nr: 'Firma-Nr.',
      dimension01_list: 'Dimension01 verwenden',
      dimension01: 'Dimension01',
      kontonummer: 'Kontonummer',
      rechnungskondition: 'Rechnungskondition',
      privat_sachk_kostart: 'Privatpersonen Sachk./Kostenart',
      positionstext: 'Positionstext verwenden',
      positionstext_opt: 'Positionstext mit',
      posten_kurs: 'Posten-"Kurs" in Belegposition',
      fibu_kore_belegpos: 'FibuKoreBelegpos. (KostStelle/KostTräger)',
      export_file: 'Export',
      ktokorrentkennzeichen: 'Kontokorrentkennzeichen',
      zahlungsbedingung: 'Zahlungsbedingung',
      datev_booking_year: 'Buchungsjahr',
      datev_period_start: 'Buchungsperiode-Anfang',
      export_paypal_txid: 'PayPal-Transaktionsnr.',
      deb_paypal: 'Deb-Nr. für Paypal',
      datev_mit_posten: 'mit Posten',
      bu_schluessel_19: 'BU-Schlüssel 19%',
      bu_schluessel_7: 'BU-Schlüssel 7%',
      bu_schluessel_0: 'BU-Schlüssel 0%'
    },
    help: {
      account_tn_type: 'Exportformat für Teilnehmerrechnungen.',
      account_dz_type: 'Exportformat für Dozentenabrechnungen.',
      mandant_id: 'Mandant-Id der Zielbuchhaltung, z. B. im BRK: 370.',
      mandant: 'Mandant der Zielbuchhaltung.',
      deb_beginn_option: 'Auswahl für eine vorangestellte Debitorennummer.',
      deb_beginn: 'Exportformat der Debitorennummer. Beispiel: 00xxxxxx.',
      deb_sz: 'Debitorennummer für Selbstzahler, wenn keine individuelle Nummer vorhanden ist.',
      rgn_nr_beginn: 'Format oder Startbestandteil der Rechnungsnummer im Export.',
      rgn_date: 'Buchungsdatum für Barzahler.',
      mitbuchkto: 'Mitbuchkonto im Export.',
      erloeskonto: 'Erlöskonto im Export.',
      kostenstelle: 'Kostenstelle im Export.',
      mahnstrg: 'Mahnstrategie für die Schnittstelle.',
      zahlungsbed_bg: 'Zahlungsbedingungen für Berufsgenossenschaften.',
      zahlungsbed_sz_fa: 'Zahlungsbedingungen für Firmen und Selbstzahler.',
      buchtxt_option: 'Auswahl, wie der Buchungstext gebildet wird.',
      buchtxt: 'Buchungstext; alte Schnittstellen begrenzen ihn teilweise auf 30 Zeichen.',
      buch_datum: 'Buchungsdatum, das in die Exportdatei geschrieben wird.',
      rng_nr_current: 'Aktuelle Rechnungsnummer aus dem Mandanten.',
      rng_to_nr_msg: 'Maximale Rechnungsnummer für Warnhinweise.',
      rng_to_nr_pre_msg: 'Warnung, wenn sich der Nummernkreis dem Maximum nähert.',
      deb_nr_current: 'Aktuelle Debitorennummer aus dem Mandanten.',
      deb_to_nr_msg: 'Maximale Debitorennummer für Warnhinweise.',
      deb_to_nr_pre_msg: 'Warnung, wenn sich der Debitorennummernkreis dem Maximum nähert.',
      buch_nav_exp: 'Legt den Navision-Exportumfang fest.',
      buch_dat_exp: 'Legt den Datev-Exportumfang fest.',
      expfeld1: 'Individuelles Exportfeld 1.',
      expfeld2: 'Individuelles Exportfeld 2.',
      expfeld3: 'Individuelles Exportfeld 3.',
      expfeld4: 'Individuelles Exportfeld 4.',
      sz_out: 'Selbstzahler beim Export aus der Kursübersicht ausschließen.',
      belegfeld2_mode: 'Quelle für Belegfeld 2.',
      belegfeld2: 'Manueller Wert für Belegfeld 2.',
      batch_booking: 'Stapelbuchung aktivieren.',
      extf_activ_debitoren: 'Stapelbuchung zusammen mit Debitorendaten exportieren.',
      consultant_number: 'Datev-Beraternummer.',
      mandant_number: 'Datev-Mandantennummer.',
      datev_belegnummer: 'Quelle für die Belegnummer.',
      deb_only_scope: 'Legt fest, für welche Empfänger Debitorennummern verwendet werden.',
      deb_only_sz_fa: 'Debitorennummer für den gewählten Bereich.',
      recipient_in_invoice: 'Empfänger zusätzlich neben dem Buchungstext ausgeben.',
      buchtxt_max_len: 'Maximale Länge des Buchungstextes.',
      gs_and_rng: 'Gutschriften mit verknüpfter Rechnung exportieren.',
      extf_b_leistungsdatum: 'Leistungsdatum in den Export aufnehmen.',
      extf_i_sachkontenlaenge: 'Sachkontenlänge für den Datev-Export.',
      content_kost1: 'Quelle für Kostenstelle 1.',
      bool_kost2: 'Kostenstelle 2 aus den Kursgrundeinstellungen übernehmen.',
      extf_bez_umsatz: 'Spaltenbeschriftung für Umsatz.',
      extf_bez_sollhaben: 'Spaltenbeschriftung für Soll/Haben.',
      extf_bez_wkzumsatz: 'Spaltenbeschriftung für WKZ Umsatz.',
      extf_bez_konto: 'Spaltenbeschriftung für Konto.',
      extf_bez_gegenkonto: 'Spaltenbeschriftung für Gegenkonto.',
      extf_bez_buschluessel: 'Spaltenbeschriftung für BU-Schlüssel.',
      extf_bez_kostenst1: 'Spaltenbeschriftung für Kostenstelle 1.',
      extf_bez_leistungsdatum: 'Spaltenbeschriftung für Leistungsdatum.',
      firmennummer: 'Firmennummer für die Schnittstelle.',
      booking_period: 'Buchungsperiode für Diamant.',
      rgn_to_belegnr: 'Rechnungsnummer als Belegnummer verwenden.',
      zusatzfeld_in_buchungstext: 'OP-Zusatzfeld in den Buchungstext übernehmen.',
      k_ks_kursnr: 'Kursnummer als Kostenträger verwenden.',
      projectdata_kursnr: 'Projekt mit Kursnummer befüllen.',
      renr_o_bindestr: 'Rechnungsnummer ohne Bindestriche exportieren.',
      kursnr_o_bindestr: 'Kursnummer ohne Bindestriche exportieren.',
      mit_posten: 'Posten im Export mit übergeben.',
      with_masterdata: 'Stammdatensatz im Export mit übergeben.',
      diamant_split_export_files: 'Debitoren und Buchungen in getrennte Dateien schreiben.',
      diamant_f_geschaeftskennzeichen: 'Diamant F-Satz Feld 5.',
      diamant_f_belegart: 'Diamant F-Satz Feld 6.',
      diamant_g_steuerschluessel_aus_mwst: 'Steuerschlüssel aus MwSt ableiten.',
      diamant_g_steuersatz_leer: 'Steuersatz im G-Satz leer lassen.',
      diamant_s_bezeichnung_format: 'Format der Adressdaten im S-Satz.',
      diamant_s_mahnart: 'Mahnart im S-Satz.',
      diamant_s_zahlungskondition: 'Zahlungskondition im S-Satz.',
      diamant_s_konzernobjekt: 'Konzernobjekt im S-Satz.',
      diamant_v_barcode_quelle: 'Quelle für den Barcode im V-Satz.',
      belegart: 'Belegart der Schnittstelle.',
      buchungskreis: 'Buchungskreis der Schnittstelle.',
      deb_sz_general: 'Nur bei Selbstzahlern hinterlegte Debitorennummer verwenden.',
      bgfa_frist: 'Zahlungsfrist bei Firmen oder Berufsgenossenschaften.',
      sz_frist: 'Zahlungsfrist bei Selbstzahlern.',
      firma_nr: 'Firmennummer für eGecko.',
      dimension01_list: 'Dimension01 im Export verwenden.',
      dimension01: 'Wert für Dimension01.',
      kontonummer: 'Kontonummer der Schnittstelle.',
      rechnungskondition: 'Rechnungskondition der Schnittstelle.',
      privat_sachk_kostart: 'Sachkonto und Kostenart für Privatpersonen.',
      positionstext: 'Positionstext in Belegpositionen verwenden.',
      positionstext_opt: 'Quelle für den Positionstext.',
      posten_kurs: 'Posten "Kurs" in Belegposition übernehmen.',
      fibu_kore_belegpos: 'Konfiguration für KostStelle/KostTräger in FibuKoreBelegposition.',
      export_file: 'Legt fest, welche Dateien exportiert werden.',
      ktokorrentkennzeichen: 'Verknüpfung der Nebenbuchhaltung mit der Hauptbuchhaltung.',
      zahlungsbedingung: 'Zahlungsbedingung in der Zielbuchhaltung.',
      datev_booking_year: 'Buchungsjahr des Exports; leer = aktuelles Jahr.',
      datev_period_start: 'Buchungsperiode-Anfang (Monat); leer = Monat des Belegdatums.',
      export_paypal_txid: 'PayPal-Transaktionsnummer mit exportieren.',
      deb_paypal: 'Debitorennummer für Rechnungen mit PayPal-Zahlung.',
      datev_mit_posten: 'Rechnungsposten als eigene Buchungszeilen (Splittbuchung) exportieren.',
      bu_schluessel_19: 'BU-Schlüssel für 19 % Mehrwertsteuer.',
      bu_schluessel_7: 'BU-Schlüssel für 7 % Mehrwertsteuer.',
      bu_schluessel_0: 'BU-Schlüssel für steuerfreie Posten.'
    },
    messages: {
      saved: 'Schnittstellen wurden gespeichert.',
      load_error: 'Schnittstellen konnten nicht geladen werden.',
      save_error: 'Schnittstellen konnten nicht gespeichert werden.',
      no_settings: 'Für dieses Format gibt es keine Einstellungen.'
    }
  },
  layoutSettings: {
    title: 'Layout',
    grid: {
      sectionTitle: 'Layouts',
      nameColumn: 'Name',
      descriptionColumn: 'Beschreibung',
      usedByColumn: 'Genutzt von',
      changedColumn: 'Geändert',
      systemBadge: 'System',
      unusedHint: 'Bislang ungenutzt',
      notDeletableTooltip: 'Nicht löschbar (System-Layout oder in Benutzung)',
      forkAction: 'Neues Layout',
      deleteAction: 'Löschen',
      deleteConfirmTitle: 'Layout löschen',
      deleteConfirmMessage: 'Soll das Layout "{name}" wirklich gelöscht werden?',
      deleteSuccess: 'Das Layout wurde gelöscht.',
      deleteError: 'Das Layout konnte nicht gelöscht werden.',
      loadError: 'Die Layouts konnten nicht geladen werden.'
    },
    deleteLog: {
      title: 'Gelöschte Layouts',
      nameColumn: 'Name',
      dateColumn: 'Datum',
      empty: 'Keine gelöschten Layouts vorhanden.'
    },
    forkDialog: {
      title: 'Neues Layout erstellen',
      nameLabel: 'Name',
      descriptionLabel: 'Beschreibung',
      sourceHint: 'Abgeleitet von "{name}"',
      confirmBtn: 'Erstellen',
      cancelBtn: 'Abbrechen',
      saveSuccess: 'Das Layout wurde erstellt.',
      saveError: 'Das Layout konnte nicht erstellt werden.',
      nameRequired: 'Bitte einen Namen angeben.'
    },
    editor: {
      selectHint: 'Bitte links ein Layout auswählen.',
      noEditableRegionsHint: 'Dieses Layout hat keine bearbeitbaren Bereiche.',
      scaffoldTitle: 'Inhalt',
      configuratorTitle: 'Konfigurator',
      moduleSimulationLabel: 'Modul simulieren',
      saveBtn: 'Speichern',
      saveSuccess: 'Das Layout wurde gespeichert.',
      saveError: 'Das Layout konnte nicht gespeichert werden.',
      previewBtn: 'Vorschau',
      previewError: 'Die Vorschau konnte nicht geladen werden.',
      selectedLayoutLabel: 'Layout: {name}',
      templatePlaceholderText: 'Hier wird später das Template gerendert',
      saveOverwriteConfirm: {
        dialogTitle: 'Layout speichern',
        message: 'Änderung des Layouts übernehmen, oder neues Layout speichern?',
        applyButton: 'Übernehmen',
        newLayoutButton: 'Neues Layout',
        cancelButton: 'Abbrechen'
      }
    }
  },
  client: {
      last_change_tooltip: 'Letzte Änderung: {date}\nBenutzer: {user}',
      customer_copy: 'Kundenkopie',
      club_data: 'Vereinsdaten',
      more_options: 'weitere Optionen',
      moduleAssignmentTooltip: 'Zuordnung Modul: {modules}',
      headquarters_suffix: '( Zentrale )',
      search_count: 'Teilnehmer: {count}',
      search_placeholder_person: 'Name, Vorname',
      search_placeholder_company: 'Firmenname',
      delete_client: 'Kunden löschen',
      delete_client_confirm: 'Möchten Sie den Kunden wirklich löschen?',
      delete_client_zentrale_warning: 'Der Kunde ist eine Zentrale. Folgende Firmen verlieren die Verbindung:',
      delete_client_courses_warning: 'Der Kunde ist in folgende laufende oder zukünftige Kurse eingetragen:',
      delete_client_blocked: 'Der Kunde kann nicht gelöscht werden, da er noch Kundenbeziehungen in folgenden Modulen hat: {modules}. Bitte löschen Sie bei Bedarf zuerst die Kundenbeziehung/en, entweder in den einzelnen Modulen oder in der Kundenmaske unter "Kundenbeziehung".',
      delete_client_not_possible: 'Der Kunde kann hier nicht gelöscht werden.',
      delete_client_module: {
        av: 'Aktiven',
        fmv: 'FMV',
        ktv: 'Kurse',
        ls: 'Akademie',
        kifam: 'Familie'
      },
      wizard: {
        title_person: 'Neuer Kunde',
        title_company: 'Neue Firma',
        title_copy_person: 'Kundenkopie – Person',
        title_copy_company: 'Kundenkopie – Firma',
        copy_banner_title: 'Sie erstellen eine Kopie von {name} — bitte alle Angaben prüfen.',
        copy_banner_included: 'Übernommen: Stammdaten, Kontaktdaten, Rechnungsadresse, Firmen-Zusatzdaten (USt-ID, Steuernummer, Zahler, Kostenstelle), passende Kundenbeziehung.',
        copy_banner_excluded: 'Nicht übernommen: Bankverbindung, Mandatsnummer, Mitgliedsnummer, Debitorenkonto — bitte bei Bedarf neu anlegen.',
        copy_badge: 'Kopie',
        steps: {
          stammdaten: 'Stammdaten',
          weitere: 'Weitere Angaben',
          extras: 'Bank & Rechnungsadresse',
          summary: 'Zusammenfassung'
        }
      },
      new_person_tooltip: 'neuer Kunde',
      new_company_tooltip: 'neue Firma',
      title_master: 'Stammdaten',
      // KDB-2194: renamed "Ansprechpartner" to "Ansprechperson"
      title_employee: 'Ansprechperson/Mitarbeiter',
      employee_overview: 'Mitarbeiterübersicht',
      title_office: 'Dienstlich',
      title_contact: 'Kontaktdaten',
      title_invoice_adress: 'Rechnungsadresse',
      default_invoice_address: 'Standard-Rechnungsadresse',
      course_invoice_addresses: 'Kursrechnungsadressen',
      open_course: 'Kurs öffnen',
      title_bank: 'Bankverbindung',
      bank_update_title: 'Bankdaten aktualisieren',
      bank_update_message: 'Die IBAN-Prüfung hat abweichende Daten ergeben. Soll BIC und Bankname automatisch aktualisiert werden?',
      title_additional_information: 'Zusatzinformation',
      title_customer_account: 'Kundenkonto',
      invoice_adress_opt: 'Rechnungsanschrift',
      anrede: 'Anrede',
      title: 'Titel',
      firstname: 'Vorname',
      lastname: 'Nachname',
      customer_id: 'KundenID',
      customer_number: 'Mitgliedsnummer',
      password: 'Passwort',
      deb_konto: 'Debitorennummer',
      drk_serverId: 'DRK-ServerID',
      language: 'Sprache',
      family_status: 'Familienstand',
      birthday: 'Geburtstag',
      age: 'Alter',
      birthplace: 'Geburtsort',
      conspicuous: 'auffällig',
      greetings: 'Briefanrede',
      company_org_1: 'Firma/Org',
      company_org_2: 'Firma/Org Zusatz',
      responsible_bg: 'zust. BG.',
      vat_id: 'UST-ID Nr.',
      tax_code: 'Steuer-Nr.',
      cost_center: 'Kostenstelle',
      parent_company: 'Zentrale',
      position:'Position',
      department:'Abteilung',
      work:'Beruf',
      function: 'Funktion',
      category: 'Kategorie',
      kategorie: 'Kategorie',
      marketing_group: 'Marketinggruppe',
      marketing_groups: 'Marketinggruppen',
      marketing_groups_none: 'Keine Marketinggruppen für dieses Modul vorhanden',
      free_field_1: 'Stichwort 1',
      free_field_2: 'Stichwort 2',
      comment_notice: 'Bemerkung',
      comment_note: 'Anmerkung',
      addition_notice: 'Stichwort 3',
      reference_person: 'Bezugsperson',
      phone_private: 'Telefon privat',
      phone_office: 'Telefon dienstlich',
      phone_mobile: 'Mobil',
      street: 'Strasse',
      houseNumber: 'Hausnummer',
      fax: 'Fax',
      zip: 'PLZ',
      city: 'Stadt',
      addition: 'Adresszusatz',
      country: 'Land',
      used_in_modul: 'verw. in Modul',
      used_in_modules: 'Verwendet in',
      bank_not_in_module: 'für {module} nicht hinterlegt',
      bank_replace_title: 'Bankverbindung ersetzen',
      bank_replace_message: 'In diesem Modul ist bereits eine andere Bankverbindung hinterlegt. Soll sie durch diese ersetzt werden?',
      account_holder: 'Kontoinhaber',
      bankname: 'Bankname',
      iban: 'IBAN',
      bic: 'BIC',
      konto: 'Konto',
      blz: 'BLZ',
      mandat: 'Mandat',
      mandat_date: 'Mandat Datum',
      key_number: 'Schlüsselnummer',
      referencePersonTyp: 'Art der Bezugsperson',
      reference_person_hint: 'Nur bereits bestehende Kunden können als Bezugspersonen zugeordnet werden.',
      relation : 'Kundenbeziehung',
      type: 'Typ',
      main_typ: 'Ansp./ Mitarbeiter',
      main_contact_main: 'Hauptansprechpartner',
      // KDB-2194: renamed "Ansprechpartner" to "Ansprechperson"
      main_contact_contact: 'Ansprechperson',
      legend: {
        title: 'Legende'
      }
  },
  course: {
    attendance_unsubscribed: 'abgemeldet (Schwarz)',
    attendance_noshow: 'NoShow (Rot)',
    attendance_appeared: 'Erschienen',
    title_course_data: 'Kursdaten',
    course_name: 'Kursbeschreibung',
    course_no: 'Kurs-Nr.',
    short: 'Kürzel',
    title: 'Kursbezeichnung',
    to: 'bis',
    appeared: 'erschienen',
    not_appeared: 'nicht erschienen',
    rng_receiver: 'RNG Empfänger',
    invoice_number: 'Rechnungsnummer',
    invoice_type: 'Rechnungsart',
    billing_period: 'Abrechnungszeitraum',
    group_course: 'Durchführungsform',
    group_payment: 'Kurszahlung (aus dem Rechnungsjournal)',
    filter_course_no: 'Kurs-Nummer',
    filter_from: 'kurs von',
    filter_to: 'kurs bis',
    version: 'Kursversion',
    internal_name: 'Kursnummer',
    vbg: 'VBG-Kursnummer',
    is_bg: 'Nur BG-Teilnehmer',
    bg_typ: 'BG-Art',
    bg_payment: 'BG-Gebühr',
    payment: 'Kursgebühr',
    mwst: 'Mehrwertsteuer',
    street: 'Straße',
    plz: 'Postleitzahl',
    city:'Ort',
    title_course_days: 'Termine',
    event_status: 'Kursstatus',
    status_planned: 'geplant',
    status_cancelled: 'fällt aus',
    status_conducted: 'wird durchgeführt',
    status_closed: 'geschlossen',
    event_status_tooltip: 'Kursübersicht - Listenfarbe:\n\n1. Status: "wird durchgeführt", jedoch mind. Teilnehmerzahl nicht erreicht == "Rot"\n2. Status: "fällt aus" == "Grau"',
    event_ue: 'Unterrichtseinheiten',
    hide_webdisplay: 'Terminspiegelung',
    hide_ongoing: 'Quereinstieg',
    maskcharge: 'Maskencharge alphanum.',
    helper_name: 'Ausbildungshelfer',
    title_course_places: 'Kursplätze',
    course_places_auto_calculated: 'Die Werte werden automatisch berechnet.',
    student_amount_now: 'Teilnehmer bisher',
    student_register_now: 'offen Onlineanmeldungen',
    tn_reserved: 'Reservierungen',
    student_amount_min: 'Teilnehmer min.',
    student_amount_max: 'Teilnehmer max.',
    student_amount_free: 'freie Plätze',
    title_course_event: 'Kursveranstaltung',
    association_mandant: 'Verein/Mandant',
    org_id:'Org_id',
    org_typ: 'Gliederungstyp',
    title_general_notice: 'Allgemeine Bemerkung',
    title_online_presence: 'Veröffentlichung',
    title_course_location: 'Kursort',
    kursort_info_tooltip: 'Der hier gezeigte Kursort bezieht sich auf den ersten Termin des Kurses, der ebenfalls in den Kursdaten zu finden ist. Sollte ein Kurs mehrere Termine mit unterschiedlichen Kursorten haben, ist dies in der Terminübersicht unter dem Reiter "Termine" erkennbar.',
    title_contributions: 'Beiträge',
    title_general_remarks: 'Bemerkungen Allgemein',
    organisation: 'Ortsverein',
    bookability: 'Buchbarkeit',
    bookability_public: 'öffentlich',
    bookability_closed: 'geschlossen',
    bookability_internal: 'intern',
    bookability_tooltip: '<b>öffentlich/offen:</b> Ein offener Kurs ist für alle zugänglich.\n<b>geschlossen:</b> Ein geschlossener Kurs ist nicht für alle zugänglich und findet in oder für eine Firma statt. Er ist nur über den Reservierungslink buchbar und erscheint nicht in der Websuche.\n<b>intern:</b> Ein interner Kurs richtet sich an die eigenen Mitarbeitenden und wird auf der eigenen Webseite veröffentlicht.\n\nÖffentliche und interne Kurse werden automatisch in die Websuche aufgenommen.',
    event_type: 'Kursart',
    event_type_open: 'offen',
    event_type_closed: 'geschlossen',
    event_ue_present: 'Unterrichtseinheiten Präsent',
    event_ue_online: 'Unterrichtseinheiten Online',
    company_portal: 'Firmenportal',
    show_online: 'Kurs online anzeigen',
    show_online_closed: 'Kurs online anzeigen (geschlossener Kurs)',
    company_portal_tooltip: 'Firmenportal\n\nBei „Ja“ wird dieser Termin im Firmenportal angezeigt.\nBei „Nein“ wird dieser Termin im Firmenportal ausgeschlossen.\nAusnahme: Firma in der der Kurs stattfindet.',
    hide_ongoing_tooltip: 'Quereinstieg\n\nBei „Ja“ ist ein Einstieg in laufende mehrtägige Kurse mit Anmeldung über das Onlineformular der Webseite dadurch möglich.\nBei „Nein“ ist kein Quereinstieg möglich: Mit Erreichen des Kursbeginns wird der Kurs in der Terminanzeige auf der Webseite nicht mehr aufgeführt.',
    application_deadline_date: 'Anmeldeschluss',
    publish_date: 'Kurs veröffentlicht ab',
    location_name: 'Kursort',
    location_venue: 'Veranstaltungsort',
    location_room_type: 'Raumart',
    location_site: 'Standort',
    location_room: 'Haus/Etage/Raum',
    // KDB-2194: renamed "Ansprechpartner" to "Ansprechperson"
    location_contact_person: 'Fa. Ansprechperson',
    payment_course: 'Kursbeitrag',
    payment_course_gross_info: 'Bruttobetrag inkl. Mwst',
    revenue_account: 'Erlöskonto',
    payment_external: 'Kursbeitrag Extern',
    revenue_account_external: 'Erlöskonto Extern',
    payment_hik: 'Kursbeitrag HIK',
    revenue_account_hik: 'Erlöskonto HIK',
    vat_none: 'keine MwSt.',
    vat_seven: '7% MwSt.',
    vat_nineteen: '19% MwSt.',
    note_gross_incl_vat: 'Brutto inkl. MwSt.',
    price_surcharges: 'Preisaufschläge',
    price_surcharges_bookable_online_only: 'nur online buchbar',
    price_surcharges_update_title: 'Preisaufschläge aktualisieren',
    price_surcharges_update_message: 'Möchten Sie die Daten aus den Kursgrundeinstellungen übernehmen und speichern?',
    price_surcharges_update_empty: 'Es wurden keine Preisaufschläge in den Kursgrundeinstellungen gefunden.',
    price_surcharges_update_error: 'Die Preisaufschläge konnten nicht aktualisiert werden.',
    price_surcharges_update_missing_course_type: 'Für diesen Kurs ist keine Kursbezeichnung hinterlegt.',
    price_reductions: 'Ermäßigungen',
    price_reductions_update_title: 'Ermäßigungen aktualisieren',
    price_reductions_update_message: 'Möchten Sie die Daten aus den Kursgrundeinstellungen übernehmen und speichern?',
    price_reductions_update_empty: 'Es wurden keine Ermäßigungen in den Kursgrundeinstellungen gefunden.',
    price_reductions_update_error: 'Die Ermäßigungen konnten nicht aktualisiert werden.',
    price_reductions_update_missing_course_type: 'Für diesen Kurs ist keine Kursbezeichnung hinterlegt.',
    course_designations: 'Kursbezeichnungen',
    surcharge_participant_invoice_item: 'Preisaufschlag der Teilnehmer/Rechnungsposten',
    surcharge_per_participant_invoice_item: 'Preiszuschlag je Teilnehmer (Rechnungsposten)',
    reduction_course_fee: 'Ermäßigung der Kursgebühr',
    reduction_per_course_fee: 'Ermäßigung je Teilnehmer (Kursgebühr)',
    reduction_type: 'Rabattart',
    surcharge_selection: 'Auswahl',
    value: 'Wert',
    editor: 'Bearbeiter',
    activation_date: 'Aktivierungsdatum',
    include_vat: 'inkl. MwSt.',
    gross_amount: 'Betrag (Brutto)',
    surcharge_type_currency: 'Betrag',
    surcharge_type_percentage: 'Prozent',
    flat_rate: 'Pauschalbetrag',
    flat_rate_company: 'Pauschalbetrag Firma',
    note_flat_rate_without_participant_prices: 'Komplettpreis ohne Teilnehmerpreise',
    general_remarks: 'Allgemeine Bemerkungen',
    waitlist: 'Warteliste',
    title_event_dates: 'Datum (einzelne Tage/Zeit)',
    title_company: 'Kurs für oder in Firmen',
  },
  courseCreate: {
    wizard_title: 'Neuen Kurs anlegen',
    step_kursdaten: 'Kursdaten',
    step_termin: 'Termin',
    step_beitraege: 'Beiträge',
    step_online: 'Online & Bemerkung',
    step_summary: 'Zusammenfassung',
    confirm_title: 'Kurs anlegen',
    confirm_message: 'Soll der Kurs jetzt gespeichert werden?',
    field_required: 'Pflichtfeld',
    validation_required: 'Bitte alle Pflichtfelder ausfüllen.',
    saved_success: 'Kurs erfolgreich angelegt.',
    saved_error: 'Fehler beim Anlegen des Kurses.',
    post_save_title: 'Teilnehmer oder Reservierungen anlegen?',
    post_save_message: 'Möchten Sie jetzt Teilnehmer oder Reservierungen für diesen Kurs anlegen?',
    ls_surcharge_hint: 'Zuschläge und Ermäßigungen können nach der Erstellung in den Stammdaten konfiguriert werden.',
    location_loading: 'Kursort wird geladen ...',
    room_hint: 'Vorhandenen Kursraum auswählen oder neuen Namen eintippen. Ein neuer Raum wird beim Speichern angelegt.',
    room_none: 'Keine Räume für diesen Ort vorhanden. Neuen Namen eintippen.',
    area: 'Bereich',
  },
  courseMaterials: {
    title: 'Kursmaterialien',
    newMaterial: 'Neues Material',
    dialogTitleNew: 'Neues Material',
    tabs: {
      assignment: 'Zuordnung zu Kursen'
    },
    assignMany: {
      tooltip: 'Ausgewählte Materialien zu Kurs(en) hinzufügen',
      title: '{count} ausgewählte Materialien zu Kurstypen zuordnen',
      hint: 'Die gewählten Kurstypen werden ergänzt, bestehende Zuordnungen bleiben erhalten. Fehlt einem Material das Modul eines Kurstyps, wird es bei „Verfügbar für Module“ ergänzt.',
      noSelection: 'Bitte ein oder mehrere Materialien auswählen.',
      saved: '{added} Zuordnungen für {materials} Materialien ergänzt.'
    },
    wizard: {
      stepMaterial: 'Material',
      confirmTitle: 'Material anlegen',
      confirmMessage: 'Soll das Material jetzt gespeichert werden?'
    },
    dialogTitleEdit: 'Material bearbeiten',
    detail: 'Materialdetail',
    cancel: 'Abbrechen',
    notAssigned: 'nicht zugeordnet',
    searchTooltip: 'Durchsucht Name und Nummer der Materialien. Es genügt ein Teil des Begriffs, z. B. „Phantom“ oder „31“.',
    notAssignedTooltip: 'Das Material ist keiner Kursbezeichnung zugeordnet und wird daher in keinem Kurs berechnet.',
    columns: {
      number: 'Nummer',
      name: 'Name',
      price: 'Preis',
      count: 'Menge',
      area: 'Bereich',
      courseday: 'je Kurstag',
      modules: 'Module',
      courseTypes: 'Kurstypen',
      courseAssignment: 'Zuordn. Kurs',
      unitPrice: 'E-Preis',
      participants: 'Teiln.',
      totalPrice: 'G-Preis'
    },
    areaShort: {
      s: 'Teiln.',
      c: 'Kurs'
    },
    area: {
      s: 'Teilnehmermaterial',
      c: 'Kursmaterial'
    },
    fields: {
      name: 'Name',
      number: 'Nummer',
      count: 'Menge',
      countSuffix: 'Stückzahl',
      pricePerParticipant: 'Preis je TN',
      pricePerCourse: 'Preis je Kurs',
      courseday: 'je Kurstag',
      modules: 'Verfügbar für Module',
      description: 'Beschreibung'
    },
    image: {
      label: 'Bild',
      none: 'Kein Bild vorhanden',
      change: 'Ändern',
      uploaded: 'Bild gespeichert',
      deleted: 'Bild gelöscht',
      deleteTitle: 'Bild löschen',
      deleteMessage: 'Möchten Sie das Bild des Materials wirklich löschen?'
    },
    assignment: {
      title: 'Materialeinreihung zu den Kursen',
      available: 'Mögliche Kurse',
      availableTooltip: 'Die Liste zeigt die Kursbezeichnungen der unter „Verfügbar für Module“ ausgewählten Module. Ändert sich die Modulauswahl, ändert sich auch die Anzeige.',
      assigned: 'Material zu Kursen',
      courseDefault: 'Kursbezeichnung',
      search: 'Kursbezeichnung suchen',
      module: 'Modul',
      required: 'Bitte mindestens eine Kursbezeichnung zuordnen.'
    },
    validation: {
      nameRequired: 'Bitte einen Namen eingeben.',
      modulesRequired: 'Bitte mindestens ein Modul auswählen.'
    },
    delete: {
      title: 'Material löschen',
      message: 'Möchten Sie das Material wirklich löschen?'
    },
    migration: {
      title: 'Kursmaterialien aus dem Altsystem',
      legendTransfer: 'Übernahme aus dem Altsystem',
      legendSeed: 'Beispielmaterialien',
      pendingIntro: 'Für diesen Mandanten werden die Kursmaterialien aus dem Altsystem übernommen:',
      previewMaterials: 'Materialien: {count}',
      previewImages: 'Bilder, die kopiert werden: {count}',
      previewModules: 'Materialien, bei denen die verfügbaren Module gespeichert werden: {count}',
      previewOrphaned: 'Zuordnungen zu nicht mehr vorhandenen Kursbezeichnungen, die entfernt werden: {count}',
      previewImagesMissing: 'Hinweis: {count} Bilder sind im Altsystem nicht mehr vorhanden und werden nicht übernommen.',
      emptyIntro: 'Es sind noch keine Materialien vorhanden. Sollen Beispielmaterialien angelegt werden?',
      transferred: 'Übernahme abgeschlossen: {materials} Materialien, {images} Bilder kopiert.',
      seeded: 'Beispielmaterialien angelegt: {count}'
    },
    ofCourse: {
      title: 'Kursmaterialien: {name}',
      summary: 'Kurstage: {courseDays} · Teilnehmer: {participants}',
      selectHint: 'Material in der Liste auswählen, um die Details anzuzeigen.',
      csvError: 'Der CSV-Export ist fehlgeschlagen.'
    }
  },
  courseSummary: {
    actions: {
      newCourse: 'Neuer Kurs',
      csvExport: 'CSV-Export',
      associationData: 'Vereinsdaten',
      moreOptions: 'Weitere Optionen',
      moveParticipantsToCourse: 'Teiln. in Kurs verschieben',
      selectCoursesFirst: 'Bitte zuerst Kurse in der Liste auswählen',
      reset: 'Reset',
      filter: 'Filter',
      deleteTemplate: 'Vorlage löschen',
      deleteCourse: 'Kurs löschen'
    },
    scopes: {
      searchTemplates: 'Suchvorlagen',
      currentCourses: 'Aktuelle Kurse',
      currentCoursesTooltip: 'Aktuelle Kurse der nächsten Monate (ab {date})',
      notBilledCourses: 'Nicht abgerechnete Kurse',
      billedCourses: 'Abgerechnete Kurse',
      thisWeek: 'Diese Woche',
      thisMonth: 'Diesen Monat',
      thisYear: 'Dieses Jahr'
    },
    filters: {
      courseNumber: 'Kursnummer',
      courseName: 'Kursbezeichnung',
      courseFrom: 'Kurs von',
      courseTo: 'Kurs bis',
      courseTypes: 'Kurstypen',
      courseStatus: 'Kursstatus',
      periodRange: 'Zeitraum',
      participant: 'Teilnehmer',
      teachers: 'Fachlehrkräfte',
      withoutTeachers: 'ohne Lehrkräfte',
      withoutTeachersInline: 'ohne Lehrkräfte',
      company: 'Firma',
      companyCourse: 'Firmenkurs',
      freePlaces: 'Freie Plätze',
      freePlacesCount: 'Anzahl',
      publishedFrom: 'Veröffentlicht ab',
      localAssociation: 'Vereinsdaten OV',
      courseOpenClosed: 'Kurs (offen/geschlossen/intern)',
      module: 'Modul'
    },
    options: {
      all: 'Alle',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      conducted: 'Wird durchgeführt',
      cancelled: 'Fällt aus',
      booked: 'Ausgebucht',
      free: 'Frei',
      count: 'Anzahl',
      pastCourses: 'Vergangene Kurse',
      futureCourses: 'Zukünftige Kurse',
      withParticipants: 'Mit Teilnehmern',
      withoutParticipants: 'Ohne Teilnehmer',
      minTnNotReached: 'min. TN nicht erreicht',
      maxTnExceeded: 'max. TN überschritten',
      withoutTeachers: 'Ohne Lehrkräfte',
      onlyUnsettled: 'Nicht abgerechnet',
      onlySettled: 'Abgerechnet',
      onlyFreePlaces: 'Kurse mit freien Plätzen',
      emptyLocalAssociation: 'Leer'
    },
    columns: {
      number: 'Nr.',
      numberTooltip: 'Kurs-Nr.',
      contraction: 'Kürz.',
      contractionTooltip: 'Kürzel',
      designation: 'Bez.',
      designationTooltip: 'Kursbezeichnung',
      localAssociation: 'Vereinsdaten OV',
      day: 'Tag',
      begin: 'Beg.',
      beginTooltip: 'Beginn',
      at: 'um',
      end: 'Ende',
      min: 'Min.',
      minTooltip: 'Mindest-Teilnehmer',
      max: 'Max.',
      maxTooltip: 'Maximal-Teilnehmer',
      places: 'Pl.',
      placesTooltip: 'Plätze',
      reservations: 'Res.',
      reservationsTooltip: 'Reservierung',
      participantsShort: 'Teiln.',
      participantsTooltip: 'Teilnehmer',
      companyOrganizer: 'Firm./Ausr.',
      companyOrganizerTooltip: 'Firma / Ausrichter',
      vbg: 'VBG',
      vbgTooltip: 'VBG-Nr.',
      teachers: 'Fachl.',
      teachersTooltip: 'Fachlehrkräfte',
      room: 'Raum',
      place: 'Ort',
      print: 'Druck',
      billingShort: 'Abgr.',
      billed: 'Abgerechnet'
    },
    headerGroups: {
      course: 'Kurs',
      date: 'Datum',
      participants: 'Teilnehmer',
      event: 'Veranstaltung'
    },
    legend: {
      title: 'Legende',
      minimumReached: 'Blau: Mindestanzahl der Teilnehmer wurde erreicht',
      minimumMissing: 'Rot: Mindestanzahl der Teilnehmer wurde nicht erreicht',
      cancelled: 'Grau: Kurs fällt aus',
      teacherWarning: 'Bei durchgeführten Kursen fehlen Fachlehrkräfte an einzelnen Terminen'
    },
    tooltips: {
      participantStatus: 'Teilnehmer: {current} / Mindest-Teilnehmer: {minimum}',
      minimumReached: 'Die Mindestanzahl der Teilnehmer wurde erreicht.',
      minimumMissing: 'Die Mindestanzahl der Teilnehmer wurde nicht erreicht.',
      noParticipants: 'Es sind keine Teilnehmer vorhanden.',
      teacherWarning: 'Achtung: Für {count} Termin(e) ist keine Fachlehrkraft hinterlegt.',
      freePlacesBooked: 'Zeigt nur Kurse ohne freie Plätze.',
      freePlacesAvailable: 'Zeigt nur Kurse mit mindestens einem freien Platz.',
      freePlacesCount: 'Zeigt Kurse mit genau dieser Anzahl oder mehr freien Plätzen (freie Plätze ≥ Wert).',
      publishedFrom: 'Zeigt Kurse, die bis zu diesem Datum veröffentlicht werden.\nKurse ohne Datum sind immer sichtbar.',
      moduleCourseType: 'Kurstyp: {title}',
      moduleCourseContraction: 'Kürzel: {contraction}'
    },
    errors: {
      flagUpdate: 'Änderung konnte nicht gespeichert werden',
      templateSave: 'Vorlage konnte nicht gespeichert werden',
      templateDelete: 'Vorlage konnte nicht gelöscht werden',
      mixedModuleSelection: 'Bitte nur Kurse aus einem Modul für Briefe/Mails auswählen',
      courseDeleteBlocked: 'Folgende Kurse konnten nicht gelöscht werden (Teilnehmer, Reservierung oder VBG-Nr. vorhanden): {numbers}'
    },
    messages: {
      templateSaved: 'Vorlage wurde gespeichert',
      templateDeleted: 'Vorlage wurde gelöscht',
      templateExists: 'Für diese Filter existiert bereits eine gespeicherte Vorlage',
      coursesDeleted: 'Kurs(e) wurden gelöscht'
    },
    dialogs: {
      saveTitle: 'Suchvorlage speichern',
      deleteTitle: 'Suchvorlage löschen',
      templateNameLabel: 'Name der Vorlage',
      templateNameRequired: 'Bitte einen Namen eingeben',
      deleteMessage: 'Soll die Suchvorlage "{name}" gelöscht werden?',
      deleteCourseTitle: 'Kurs löschen',
      deleteCourseInfo: 'Die Löschung von Kursen ist nur möglich, wenn keine Teilnehmer, Reservierung oder BG-Nummer (VBG) im Kurs vorhanden sind.',
      deleteCourseConfirm: '{count} Kurs(e) wirklich löschen?'
    }
  },
  courseTeachers: {
    title: 'Fachlehrkräfte',
    tabs: {
      teacherList: 'Fachlehrkraftliste',
      certificates: 'Lehrscheine'
    },
    filters: {
      lastname: 'Nachname',
      city: 'Ort/Ortsteil',
      function: 'Funktion',
      courseDefault: 'Kursbez.',
      validFrom: 'Gültig von',
      validTo: 'Gültig bis'
    },
    columns: {
      name: 'Name',
      functionTask: 'Funktion/Aufgabe',
      phone: 'Telefon',
      email: 'eMail',
      organisation: 'Gliederung',
      courseTitle: 'Kursbezeichnung',
      courseType: 'Kurstyp',
      teacherName: 'Dozent/Name',
      certificateNumber: 'Nummer',
      validFrom: 'Gültig ab',
      validTo: 'Gültig bis',
      createdAt: 'Ausgestellt am',
      note: 'Notiz'
    },
    actions: {
      edit: 'Bearbeiten'
    }
  },
  bgList: {
    title: 'BG-Liste',
    filters: {
      search: 'Suche',
      searchTooltip: 'Durchsucht: Berufsgenossenschaft, BG kurz, PLZ, Ort, Debitorennummer'
    },
    columns: {
      name: 'BG kurz',
      fullname: 'Berufsgenossenschaft',
      iban: 'IBAN',
      zip: 'PLZ',
      city: 'Ort',
      debitorNumber: 'Debitorennummer',
      unfallkasse: 'Unfallkasse'
    }
  },
  listOverview: {
    tabs: {
      search: 'Suche'
    }
  },
  clientSearch: {
    unavailable: 'Die Suche ist nicht verfügbar: Der Suchdienst (Elasticsearch) ist nicht erreichbar. Bitte wenden Sie sich an den Administrator.',
    loadFailed: 'Die Liste konnte nicht geladen werden.',
    subTabs: {
      stammdaten: 'Stammdaten',
      relations: 'Kundenbeziehungen',
      dataQuality: 'Datenqualität'
    },
    clientType: {
      all: 'Alle',
      person: 'Person',
      company: 'Firma'
    },
    filters: {
      clientType: 'Kundentyp',
      addRow: 'Filter hinzufügen',
      removeRow: 'Filter entfernen',
      field: 'Feld',
      operator: 'Bedingung',
      value: 'Wert',
      connector: {
        and: 'Und',
        or: 'Oder'
      }
    },
    operators: {
      contains: 'enthält',
      notContains: 'enthält nicht',
      startsWith: 'beginnt mit',
      endsWith: 'endet mit',
      equals: 'ist gleich',
      notEquals: 'ist nicht gleich',
      greaterThan: 'ist größer als',
      lessThan: 'ist kleiner als',
      equalsYear: 'gleich Jahr (yyyy)',
      beforeYear: 'kleiner Jahr (yyyy)',
      afterYear: 'größer Jahr (yyyy)',
      exactDate: 'Datum (tt.mm.jjjj)',
      isEmpty: 'ist leer'
    },
    relations: {
      service: 'Dienstleistung',
      serviceAll: 'Alle',
      serviceNone: 'Keine Beziehung',
      status: 'Beziehungsstatus',
      acknowledgment: 'Jahresquittung',
      contactByPhone: 'Kontakt telefonisch erlaubt',
      contactByEmail: 'Kontakt per E-Mail erlaubt',
      contactByLetter: 'Kontakt per Brief erlaubt',
      localAssociation: 'Ortsverein',
      combinationRows: 'Weitere Dienstleistungen',
      connector: {
        and: 'Und',
        or: 'Oder',
        not: 'Nicht'
      }
    },
    dataQuality: {
      criterion: 'Kriterium',
      criteria: {
        activeMultipleMemberships: 'Zwei oder mehrfache, aktive Mitgliedschaften',
        duplicateMembershipOrDonationRelations: 'Doppelte Kundenbeziehungen für Spenden oder Mitgliedschaft',
        missingRelationStatus: 'Fehlender/unbekannter Beziehungsstatus',
        missingCustomerNumber: 'Fehlende Kundennummer',
        missingNextDueDate: 'Fehlende nächste Fälligkeit',
        missingMandateNumber: 'Fehlende Mandatsnr. (Lastschrift)',
        missingMandateDate: 'Fehlendes Mandatsdatum',
        duplicateMemberNumber: 'Doppelte Mitgliedsnr.',
        relationWithoutEndDateNotActive: 'Kundenbeziehung ohne Enddatum, aber Status nicht aktiv/zahlend',
        relationWithEndDateButActive: 'Kundenbeziehung mit Enddatum, aber Status aktiv/zahlend'
      }
    },
    columns: {
      lastname: 'Name',
      firstname: 'Vorname',
      firma: 'Firma',
      zip: 'PLZ',
      city: 'Ort',
      phone: 'Telefon'
    },
    fields: {
      anrede: 'Anrede',
      titel: 'Titel',
      name: 'Name',
      vorname: 'Vorname',
      kategorie: 'Kategorie',
      bankaccountKontoInhaber: 'Konto Inhaber',
      abteilung: 'Abteilung',
      kontaktperson: 'Kontaktperson',
      position: 'Position',
      plz: 'PLZ',
      ort: 'Ort',
      strasse: 'Straße',
      telefon: 'Telefon (privat)',
      dienstlich: 'Telefon (dienstlich)',
      mobil: 'Telefon (mobil)',
      email: 'E-Mail',
      gebDatum: 'Geburtstag',
      familienstand: 'Familienstand',
      sprache: 'Sprache',
      beruf: 'Beruf',
      firma: 'Firma',
      firma2: 'Firma2',
      debKonto: 'Debitorennr.',
      bankaccountKontoBlz: 'BLZ',
      bankaccountKontoNr: 'Kontonr.',
      bankaccountKontoInstitut: 'Bank',
      bemerkung: 'Bemerkung',
      confidentialNote: 'Bemerkung / Vertraulich',
      anmerkung: 'Anmerkung',
      addField01: 'Frei 1',
      addField02: 'Frei 2',
      additionalAddress: 'Adresszusatz',
      addressStatus: 'Adressstatus',
      fax: 'Fax',
      bankaccountBic: 'BIC',
      bankaccountIban: 'IBAN',
      marketingGroupId: 'Marketinggruppe',
      relationStopDate: 'Beitragsstopp',
      relationStartDate: 'Beitrittsdatum',
      relationEndDate: 'Kündigungsdatum',
      relationPaymentTypeId: 'Abrechnungszeitraum',
      relationPaymentMethodId: 'Zahlungsform',
      relationAnnualSubscription: 'Jahresbeitrag',
      relationCustomerNumber: 'Mitgliedsnummer',
      prenotificationPassDate: 'Abbuchungsauftrag vom',
      prenotificationPassCheck: 'Abbuchungsauftrag',
      acknowledgment: 'Jahresquittung',
      advertiser: 'Werbung',
      currentCandidates: 'Werbername',
      newspaperId: 'Zeitungstitel',
      newspaperBarrier: 'Zeitungssperre',
      repatriation: 'Rückholdienst',
      repatriationService: 'Flugdienst',
      dueNotice: 'Kündigungsgrund',
      memberPassCheck: 'Mitgliedsausweis',
      memberPassDate: 'Mitgliedsausweis am',
      bankaccountMandatsnummer: 'Mandat',
      bankaccountMandatsdatum: 'Mandatsdatum',
      terminationPassCheck: 'Kündigungsbrief',
      terminationPassDate: 'Kündigungsbrief am',
      partnerRelation: 'Partner Beziehung',
      partnerLastname: 'Partner Nachname',
      partnerFirstname: 'Partner Vorname',
      partnerTitle: 'Partner Titel',
      partnerSalutation: 'Partner Anrede',
      partnerStreet: 'Partner Straße',
      partnerZipcode: 'Partner PLZ',
      partnerCity: 'Partner Ort',
      partnerDateOfBirth: 'Partner Geburtstag',
      welcomePassCheck: 'Willkommensbrief',
      welcomePassDate: 'Willkommensbrief am',
      registerOfficeDate: 'Einwohnermeldeamt'
    }
  },
  clientList: {
    title: 'Kundenliste',
    filters: {
      name: 'Name',
      vorname: 'Vorname',
      zip: 'PLZ',
      city: 'Ort',
      street: 'Straße',
      marketingGroup: 'Marketinggruppe',
      marketingGroupNone: 'Keine Marketinggruppe gefunden',
      templateLabel: 'Vorlage'
    },
    columns: {
      lastname: 'Name',
      firstname: 'Vorname',
      street: 'Straße',
      zip: 'PLZ',
      city: 'Ort',
      phone: 'Telefon'
    },
    detailNotAvailable: 'Die Kundenmaske ist für dieses Modul noch nicht verfügbar.',
    actions: {
      selectedCount: '{count} ausgewählt',
      delete: 'Löschen',
      labels: 'Etiketten',
      export: 'Export',
      deleteDialog: {
        title: 'Kunden löschen',
        deletable: 'Folgende Kunden werden gelöscht:',
        blocked: 'Folgende Kunden können nicht gelöscht werden:',
        reasonZentrale: 'Zentrale mit verbundenen Firmen',
        reasonActiveCourses: 'aktive oder zukünftige Kursteilnahme',
        result: '{succeeded} gelöscht, {failed} fehlgeschlagen'
      },
      labelsDialog: {
        presetLabel: 'Vorlagen von Herma',
        preset70x36: 'Herma 70×36 mm (24 pro Blatt)',
        preset70x42: 'Herma 70×42 mm (21 pro Blatt)',
        preset48x17: 'Herma 48,3×16,9 mm (64 pro Blatt)',
        fieldsLabel: 'Inhalt',
        fieldAnrede: 'Anrede, Titel',
        fieldName: 'Vorname, Name',
        fieldStreet: 'Straße',
        fieldZipCity: 'PLZ, Ort',
        fieldFirma: 'Firma',
        individualLabel: 'Individuelle Angaben',
        marginLeft: 'Abstand links',
        marginTop: 'Abstand oben',
        labelHeight: 'Etikettenhöhe',
        labelWidth: 'Etikettenbreite',
        fontSize: 'Schriftgröße',
        fontAlign: 'Ausrichtung',
        alignLeft: 'Links',
        alignCenter: 'Mitte',
        alignRight: 'Rechts',
        colsPerSheet: 'Etiketten waagerecht',
        rowsPerSheet: 'Etiketten senkrecht',
        repeatAddress: 'Adresse wiederholen',
        onceOnly: 'Adresse einmalig'
      },
      exportDialog: {
        csv: 'CSV',
        pdf: 'PDF'
      }
    }
  },
  companyList: {
    title: 'Firmenliste',
    filters: {
      name: 'Firma',
      firma2: 'Firma 2',
      zip: 'PLZ',
      city: 'Ort',
      street: 'Straße',
      marketingGroup: 'Marketinggruppe',
      marketingGroupNone: 'Keine Marketinggruppe gefunden',
      templateLabel: 'Vorlage'
    },
    columns: {
      firma: 'Firma',
      firma2: 'Firma 2',
      debKonto: 'Debitorennummer',
      street: 'Straße',
      zip: 'PLZ',
      city: 'Ort',
      phone: 'Telefon'
    },
    detailNotAvailable: 'Die Kundenmaske ist für dieses Modul noch nicht verfügbar.',
    actions: {
      selectedCount: '{count} ausgewählt',
      delete: 'Löschen',
      labels: 'Etiketten',
      export: 'Export',
      deleteDialog: {
        title: 'Firmen löschen',
        deletable: 'Folgende Firmen werden gelöscht:',
        blocked: 'Folgende Firmen können nicht gelöscht werden:',
        reasonZentrale: 'Zentrale mit verbundenen Firmen',
        reasonActiveCourses: 'aktive oder zukünftige Kursteilnahme',
        result: '{succeeded} gelöscht, {failed} fehlgeschlagen'
      },
      labelsDialog: {
        presetLabel: 'Vorlagen von Herma',
        preset70x36: 'Herma 70×36 mm (24 pro Blatt)',
        preset70x42: 'Herma 70×42 mm (21 pro Blatt)',
        preset48x17: 'Herma 48,3×16,9 mm (64 pro Blatt)',
        fieldsLabel: 'Inhalt',
        fieldAnrede: 'Anrede, Titel',
        fieldName: 'Firma, Firma 2',
        fieldStreet: 'Straße',
        fieldZipCity: 'PLZ, Ort',
        fieldFirma: 'Firma',
        individualLabel: 'Individuelle Angaben',
        marginLeft: 'Abstand links',
        marginTop: 'Abstand oben',
        labelHeight: 'Etikettenhöhe',
        labelWidth: 'Etikettenbreite',
        fontSize: 'Schriftgröße',
        fontAlign: 'Ausrichtung',
        alignLeft: 'Links',
        alignCenter: 'Mitte',
        alignRight: 'Rechts',
        colsPerSheet: 'Etiketten waagerecht',
        rowsPerSheet: 'Etiketten senkrecht',
        repeatAddress: 'Adresse wiederholen',
        onceOnly: 'Adresse einmalig'
      },
      exportDialog: {
        csv: 'CSV',
        pdf: 'PDF'
      }
    }
  },
  bgListMask: {
    title: 'Berufsgenossenschaft',
    tabs: {
      data: 'BG-Daten',
      online: 'Einstellungen Onlineanmeldung'
    },
    cards: {
      kontakt: 'Adresse & Ansprechpartner',
      bank: 'Bankverbindung',
      abrechnung: 'Abrechnung'
    },
    fields: {
      street: 'Straße',
      zip: 'PLZ',
      city: 'Ort',
      phone: 'Telefon',
      fax: 'Fax',
      mail: 'eMail',
      website: 'Website',
      ap_anrede: 'Anrede',
      ap_titel: 'Titel',
      ap_name: 'Nachname',
      ap_vorname: 'Vorname',
      kto_institut: 'Bankinstitut',
      kto_inhaber: 'Kontoinhaber',
      kto_nr: 'Kontonummer',
      kto_blz: 'BLZ',
      kto_iban: 'IBAN',
      kto_bic: 'BIC',
      kto_bemerkung: 'Bemerkung',
      debitor_number: 'Debitorennummer',
      vat_number: 'UST-ID Nr.',
      tax_number: 'Steuernummer',
      cost_center: 'Kostenstelle',
      cost_typ: 'Kostenart',
      cost_unit: 'Kostenträger',
      revenue_account: 'Erlöskonto',
      add_field_01: 'Frei 1',
      add_field_02: 'Frei 2',
      anmerkung: 'Anmerkung'
    },
    ibanInvalid: 'IBAN konnte nicht ermittelt werden.',
    debitorNumberConflict: 'Diese Debitorennummer wird bereits von einer anderen BG und einem Kunden verwendet.',
    onlineRegistration: {
      attachmentToggle: 'BG-Anhang bei Onlineanmeldung mitschicken',
      additionalText: 'Ergänzungstext'
    }
  },
  teacherMask: {
    title: 'Fachlehrkraft',
    noData: 'Keine Einträge vorhanden',
    actions: {
      csvExport: 'CSV-Export'
    },
    tabs: {
      person: 'Person',
      courses: 'Kurse',
      documents: 'Dokumente'
    },
    cards: {
      stammdaten: 'Stammdaten',
      organisation: 'Organisation',
      lehrscheine: 'Lehrscheine',
      verfuegbarkeit: 'Verfügbarkeit',
      weitereDetails: 'Weitere Details',
      sperrzeiten: 'Sperrzeiten',
      schulungen: 'Schulungen'
    },
    verfuegbarkeit: {
      weekdaysFieldset: 'Verfügbarkeit Wochentage',
      noDays: 'Keine Verfügbarkeit an Wochentagen.'
    },
    certificateAssignments: {
      title: 'Kursbezeichnungen',
      availableTitle: 'Mögliche Kursbezeichnungen',
      availableColumn: 'Kursbezeichnung',
      availableInfo: 'Alle markierten Kursbezeichnungen sind für Lehrscheine gültig.',
      availableLegendTitle: 'Legende',
      availableLegend: 'Kursiv markierte Einträge sind Kurse ohne Lehrschein-Nachweis.',
      unknownLabel: 'Unbekannt'
    },
    fields: {
      prefix: 'Anrede',
      firstname: 'Vorname',
      lastname: 'Nachname',
      position: 'Position',
      birthday: 'Geburtsdatum',
      street: 'Straße',
      zip: 'PLZ',
      city: 'Ort',
      phone: 'Telefon',
      mobile: 'Mobil',
      fax: 'Fax',
      email: 'E-Mail',
      employer_name: 'Arbeitgeber',
      employment_relation: 'Arbeitsverhältnis',
      duty_group: 'Funktionsgruppe',
      personnelnumber: 'Personalnummer',
      accession: 'Einstellungsdatum',
      wage_types_fee: 'Lohnart/Vergütung',
      description: 'Beschreibung',
      description2: 'Notizen',
      iban: 'IBAN',
      bic: 'BIC',
      weekdays: 'Wochentage',
      weekdays_notiz: 'Notiz Wochentage',
      org_name: 'Name',
      org_city: 'Stadt',
      org_zipcode: 'PLZ',
      org_street: 'Straße',
      org_phone: 'Telefon',
      org_fax: 'Fax',
      org_webpage: 'Webseite',
      blockadeTitle: 'Titel',
      dateFrom: 'Von',
      dateTo: 'Bis',
      available: 'Verfügbar',
      notiz: 'Notiz',
      trainingName: 'Schulungsbez.',
      trainingNumber: 'Schulung-Nr.',
      lessonHour: 'Unterrichtseinh.',
      trainingBegin: 'Beginn',
      trainingEnd: 'Ende',
      pointMed: 'mediz. Punkte',
      pointPaedag: 'pädag. Punkte',
      schoolName: 'Schul. Name',
      schoolStreet: 'Schul. Straße',
      schoolZip: 'Schul. PLZ',
      schoolCity: 'Schul. Stadt',
      trainingDescription: 'Schulungsbeschreibung',
      validFrom: 'Gültig von',
      validTo: 'Gültig bis',
      certNumber: 'Nummer',
      certName: 'Bezeichnung',
      certDescription: 'Notiz'
    },
    blockadeFieldsets: {
      dateRange: 'Sperrzeit von/bis',
      weekdays: 'Generelle Sperrzeit an Wochentagen'
    },
    weekdays: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag'
    },
    columns: {
      number: 'Nummer',
      certName: 'Bezeichnung',
      validFrom: 'Gültig von',
      validTo: 'Gültig bis',
      leklass: 'Leistungsklasse',
      isBg: 'BG?',
      blockadeTitle: 'Titel',
      dateFrom: 'Von',
      dateTo: 'Bis',
      available: 'Verfügbar',
      notiz: 'Notiz',
      trainingName: 'Schulungsbez.',
      trainingNumber: 'Schulung-Nr.',
      lessonHour: 'Unterrichtseinh.'
    },
    courseColumns: {
      kursnr: 'Kursnr.',
      leidextcontr: 'Kürzel',
      kursbez: 'Kursbezeichnung',
      typ: 'Kurstyp',
      date: 'Datum',
      dozKost: 'sonst. Kosten',
      dozVerg: 'Vergütung',
      openCourse: 'Kurs öffnen',
      tooltip: {
        courseNumber: 'Kursnr.: {courseNumber}',
        module: 'Modul: {module}',
        status: 'Kurs Status: {status}',
        settled: 'abgerechnete Kurse',
        unsettled: 'nicht abgerechnete Kurse',
      },
    },
    courseModules: {
      ktv: 'Kurse',
      kifam: 'Familie',
      ls: 'Akademie',
    },
    coursesTotal: 'Gesamt {year}: {amount} Euro',
    dialogs: {
      addBlockade: 'Sperrzeit hinzufügen',
      editBlockade: 'Sperrzeit bearbeiten',
      addTraining: 'Schulung hinzufügen',
      editTraining: 'Schulung bearbeiten',
      addCertificate: 'Lehrschein hinzufügen',
      editCertificate: 'Lehrschein bearbeiten'
    }
  },
  courseDefaults: {
    data_title: 'Kursbezeichnung',
    course_amount_title: 'Kursbetrag',
    course_amount_value: 'Betrag',
    course_amount_value_extern: 'Extern',
    course_amount_value_hik: 'HIK',
    course_amount_default_name_normal: 'Betrag',
    course_amount_default_name_extern: 'Extern',
    course_amount_default_name_hik: 'HIK',
    course_amount_default_Pay: ' €',
    designation: 'Bezeichnung',
    type: 'Typ',
    cost_type_paid: 'Kostenpflichtig',
    cost_type_free: 'Kostenlos',
    cost_type_request: 'Auf Anfrage',
    cost_type_hidden: 'Deaktiviert',
    edit_title: 'Kursgrundeinstellungen',
    search_title: 'Kursgrundeinstellungen',
    search_title_short: 'Suche',
    moduleName: {
      ktv: 'Kurs',
      kifam: 'Familie',
      ls: 'Akademie'
    },
    moduleTooltip: 'Modul: {module}',
    moduleTooltipInvalid: 'Zuordnung vom Kurstyp ist nicht korrekt',
    moduleFilterTooltip: 'Nach Modul filtern',
    moduleFilterAll: 'Alle',
    linkedDesignationNotFound: 'Die mit dem Kurs verknüpfte Kursbezeichnung wurde nicht gefunden.',
    contraction: 'Kürzel',
    title: 'Kursbezeichnung',
    qualification_skippable: 'Kurs ohne Lehrschein-Nachweis',
    qualification_skippable_tooltip: 'Kurs ohne Nachweis vom Lehrschein',
    affects_existing_courses_tooltip: 'Änderungen wirken sich sofort auf bereits bestehende, verbundene Kurse aus.',
    based_on_type: 'basiert auf Kurstyp',
    fee_per_course: 'Kursbetrag Brutto/EUR',
    vat: 'MwSt.',
    bg_course_type: 'BG-Kurs',
    bg_course_id: 'BG-Lehrgang',
    module: 'Modul',
    drkserver_course: 'DRK-Server-Kurs',
    drkserver_course_question: 'DRK-Server-Kurs?',
    drkserver_course_deprecated: '{name} (gelöscht)',
    lesson_hour: 'Unterrichtseinheit',
    lesson_minutes: 'je Minuten',
    subscriber_min: 'Teilnehmer min.',
    subscriber_max: 'Teilnehmer max.',
    time_start: 'Uhrzeit Beginn',
    time_end: 'Uhrzeit Ende',
    buha_title: 'Buchhaltung',
    revenue_account: 'Erlöskonto',
    cost_center: 'Kostenstelle',
    cost_unit: 'Kostenträger',
    cost_type: 'Kostenart',
    project_number: 'Projektnummer',
    individual_code: 'individuellen Code',
    notice_internal: 'Notiz (intern)',
    course_numberformat: 'autom. Kursnummer',
    course_number_duplicate: 'Kursnummer bereits vergeben',
    numbering_title: 'Kursnummer',
    numbering_dialog_title: 'Kursnummer',
    numbering_dialog_settings_title: 'Einstellung Kursnummer',
    numbering_mode_label: 'Format/Kursnummer',
    numbering_mode_0: 'Standard Wert (von Kursbezeichnung)',
    numbering_mode_1: 'lfd. Nummer (Format von Kursbez.)',
    numbering_mode_2: 'Allgem. Einstellungen (Format + lfd. Nummer)',
    numbering_format_group_title: 'Kursformat',
    numbering_format_label: 'Auswahl',
    numbering_format_preview_label: 'Format',
    numbering_counter_section_title: 'lfd. Nummer (NN)',
    numbering_type_per_course_type: 'je Kurstyp',
    numbering_type_all_designations: 'alle Kursbezeichnungen',
    numbering_locked_by_general_settings: "Kursnummer in den 'Allgemeinen Einstellungen' vornehmen.",
    numbering_start_count: 'Beginn Zählung',
    numbering_digits: 'Anzahl der Stellen',
    numbering_digits_tooltip_title: "'Anzahl der Stellen' mit vorangestellten Nullen.",
    numbering_digits_tooltip_example_2: 'Bsp.: 2 = 01, 02 ...',
    numbering_digits_tooltip_example_5: '5 = 00001, 00002, ...',
    numbering_digits_tooltip_example_7: '7 = 0000001, 0000002, ...',
    last_assigned_course_number: 'Letzte Kursnummer',
    numbering_format_1: 'Kurskürzel/Jahr/lfd. Nr. (KK-YYYY-NN)',
    numbering_format_2: 'Jahr/Kurskürzel/lfd. Nr. (YYYY-KK-NN)',
    numbering_format_3: 'Lfd. Nummer (NN)',
    numbering_format_4: 'Jahr/lfd. Nr. (YYYY-NN)',
    numbering_format_5: 'Kurskürzel/lfd. Nr. (KK-NN)',
    numbering_format_6: 'Jahr/Kostenstelle/lfd. Nr. (YYYY-KS-NN)',
    numbering_format_7: 'Jahr/indiv. Code/lfd. Nr. (YYYY-IC-NN)',
    numbering_format_8: 'Jahr/Monat/Kostenstelle/lfd. Nr. (YYYY-MM-KS-NN)',
    numbering_token_yyyy: 'Jahr (Kursjahr)',
    numbering_token_mm: 'Monat (Kursstartdatum)',
    numbering_token_dd: 'Tag (Kursstartdatum)',
    numbering_token_kk: 'Kurskürzel',
    numbering_token_ks: 'Kostenstelle',
    numbering_token_ic: 'individueller Code',
    numbering_token_nn: 'lfd. Nummer',
    registration_url: 'Link zur Seite',
    link_document: 'Link für Unterlagen',
    mail_settings_title: 'Einstellung Mailversand',
    auto_online_registration_with_confirmation_mail: 'automatisierte Übernahme Onlineanmeldungen mit Bestätigungsmail?',
    auto_online_registration_with_confirmation_mail_tooltip: 'Vollautomatische Bestätigungsmail:\n• Bei „Ja“ Eingegangene Onlineanmeldungen werden innerhalb von 5 min. automatisch übernommen und die Bestätigungsmail versendet. Zwischen 6 und 19 Uhr.\n• Bei „Nein“ übernehmen und bestätigen Sie die Onlineanmeldung manuell.',
    mail_bcc_to: 'Mail BCC an',
    mail_bcc_option_empty: '',
    mail_bcc_option_control_clerk: 'DLDB Mail-Sammeladresse',
    mail_bcc_option_collective_ap_dldb: 'DLDB Mail Ansprechperson 1',
    mail_reply_address: 'Mail Antwortadresse',
    company_registration_participants_receive_confirmation_too: 'Firmenanmeldung: Teilnehmer sollen zusätzlich zum AP die Bestätigung erhalten',
    company_registration_participants_receive_confirmation_too_tooltip: 'Vorlagen "Scheine":\n- TN-Schein A4,\n- TN-Schein A5 MONA,\n- TN-Schein A6\n... und Ableitungen davon werden als Empfänger die Firma erhalten.',
    recipient_mail_send_company_visible: "Empfänger: 'Mail(s) senden' Firma sollen angezeigt werden",
    mail_confirmation_attachment: 'Mail Bestätigung Anhang',
    updater_reductions_title: 'Ermäßigungen',
    updater_surcharges_title: 'Aufschläge',
    updater_category_tooltip_active_marks_title: 'Aktive Markierungen',
    updater_category_tooltip_changed_letters_title: 'Geänderte Briefe',
    updater_category_tooltip_loading: 'Wird geladen...',
    updater_category_tooltip_empty: 'Keine Markierungen vorhanden.',
    template_settings_title: 'Einstellung der Vorlagen',
    template_settings_edit_title: 'Einstellung der Vorlagen bearbeiten',
    template_source_list_title: 'Vorlagen für diesen Kurs',
    template_available_letters_title: 'Briefauswahl',
    template_copy_title: 'Vorlagenliste kopieren',
    template_selected_area: 'Bereich',
    template_letters_adjustment_for_area: '... für',
    template_select_row_hint: 'Bitte links auf Bearbeiten klicken, um rechts die Briefliste anzuzeigen.',
    template_selection_dialog_title: 'Vorlage auswählen',
    template_category_filter_sz: 'Es werden nur Selbstzahler-Briefe angezeigt (Kategorie SZ).',
    template_category_filter_fa: 'Es werden nur Firmen-Briefe angezeigt (Kategorie FA).',
    template_category_filter_bg: 'Es werden nur BG-Briefe angezeigt (Kategorie BG).',
    template_selection_choose_letter: 'Bitte eine Vorlage auswählen.',
    template_selection_saved: 'Vorlage erfolgreich gespeichert',
    template_selection_save_error: 'Fehler beim Speichern der Vorlage',
    template_selection_no_course: 'Speichern nicht möglich: Kursgrundeinstellung ohne ID.',
    template_left_subtitle_letters: 'Auswahl der Bereiche mit Briefnamen',
    template_left_subtitle_copy: 'Die komplette untere Liste (Bereich & Briefname) wird zur Auswahl der rechten Seite kopiert.',
    template_copy_subtitle: '... nach',
    template_table_area: 'Bereich',
    template_table_directory: 'Verzeichnis',
    template_table_letter_id: 'ID',
    template_table_letter_name: 'Briefname',
    template_directory_standard: 'Standardbrief',
    template_directory_kv: 'KV Vorlage',
    template_edit_not_implemented: 'Die Bearbeitung einzelner Vorlagen folgt im nächsten Schritt.',
    updater_dialog_title: 'Kurs-Updater',
    updater_tab_fields: 'Felder/Bereiche',
    updater_tab_courses: 'Verb. Kurse',
    updater_tooltip: 'Überträgt ausgewählte Daten dieser Kursbezeichnung auf bereits angelegte Kurse.',
    updater_description: 'Die meisten Änderungen an einer Kursbezeichnung gelten nur für Kurse, die danach neu angelegt werden. Mit dem Kurs-Updater übernehmen Sie ausgewählte Daten auch in bereits bestehende, mit dieser Bezeichnung verbundene Kurse: Wählen Sie unter „Felder/Bereiche“ die zu übernehmenden Daten und unter „Verb. Kurse“ die Kurse aus. Die bisherigen Werte dieser Kurse werden dabei überschrieben.',
    updater_dialog_title_context_prefix: 'für die Bezeichnung:',
    updater_dialog_title_with_contraction_and_designation: 'Kurs-Updater für {contraction} | {designation}',
    updater_dialog_title_with_contraction: 'Kurs-Updater für {contraction}',
    updater_dialog_title_with_designation: 'Kurs-Updater für {designation}',
    wizard_title: 'Neue Bezeichnung',
    wizard_prev: 'Zurück',
    wizard_next: 'Weiter',
    wizard_summary_title: 'Zusammenfassung',
    wizard_summary_missing_fields_title: 'Fehlende Pflichtfelder',
    wizard_validation_required: 'Dieses Feld ist erforderlich',
    wizard_validation_max_length: 'Höchstens {max} Zeichen erlaubt',
    wizard_validation_places_exceeded: 'Die eingegebenen Plätze übersteigen die verfügbaren Plätze ({free})',
    wizard_validation_required_group: 'Bitte Pflichtfelder ausfüllen.',
    wizard_validation_teacher_draft: 'Fachlehrkraft-Eintrag unvollständig. Bitte „Übernehmen“ klicken oder Eingaben leeren.',
    wizard_saved_success: 'Erfolgreich gespeichert',
    wizard_saved_with_teacher_warnings: '{failed} von {total} Fachlehrkräfte konnten nicht gespeichert werden.',
    wizard_saved_error: 'Fehler beim Speichern',
    wizard_confirm_save_title: 'Speichern bestätigen',
    wizard_confirm_save_message: 'Soll die neue Bezeichnung gespeichert werden?',
    wizard_teacher_no_data: 'Keine Daten vorhanden',
    wizard_teacher_add: 'Übernehmen',
    wizard_teacher_update: 'Übernehmen',
    wizard_teacher_remove: 'Löschen',
    teacher_settings_title: 'Vergütung der Fachlehrkräfte',
    teacher_short_label: 'Kürzel',
    teacher_description_label: 'Bezeichnung',
    teacher_valid_short_label: 'Gültig',
    teacher_valid_from_label: 'Gültig ab',
    teacher_area_label: 'Bereich',
    teacher_area_hour: 'Stundensatz',
    teacher_area_course: 'Kurssatz',
    teacher_area_day_flat: 'Tagespauschale',
    teacher_area_course_flat: 'Kurspauschale',
    teacher_amount_label: 'Betrag',
    teacher_break_minutes_label: 'Pausenzeiten',
    wizard_teacher_area_60min: 'Stundensatz (60min.)',
    wizard_teacher_area_ue: 'Unterrichtseinheit',
    wizard_teacher_area_day: 'Tagespauschale (Fachlehrkraft)',
    wizard_teacher_area_flat: 'Kurspauschale (Fachlehrkraft)'
  },
  teacher: {
    tabs_templates: 'Vorlagen',
    tabs_teachers: 'Fachlehrkräfte',
    tabs_additional_info: 'Zusatzinfo',
    tabs_preview: 'Vorschau',
    teacher_name: 'Fachlehrkraft/Name',
    certificate_no: 'Lehrschein Nr.',
    valid_from: 'Gültig ab',
    valid_to: 'Gültig bis',
    compensation: 'Vergütung',
    doz_short: 'Fachl.',
    summaryTitle: 'Fachlehrkraftübersicht',
    detailsTitle: 'Fachlehrkraftdetails',
    courseDays: {
      overviewTitle: 'Fachlehrkraftübersicht',
      teacherCount: '{count} Fachlehrkräfte',
      noData: 'Keine Fachlehrkrafttage vorhanden.',
      showDates: 'Termine anzeigen',
      hideDates: 'Termine ausblenden',
      detailsTooltip: 'Details (demnächst verfügbar)',
      settingsTooltip: 'Allgemeine Einstellungen der Fachlehrkräfte',
      moreOptionsTooltip: 'Weitere Optionen',
      deleteTooltip: 'Fachlehrkräfte vom Kurs entfernen',
      deleteTeacherAction: 'Lehrkraft löschen',
      editDialog: {
        title: 'Fachlehrkraft bearbeiten',
        room: 'Raum',
        timeRange: 'Beginn/Ende',
        teacherFunction: 'Dozentenfunktion',
        teacher: 'Fachlehrkraft',
        applyToAll: 'Dozent f. alle Termine',
        applyToAllInfo: 'Die Fachlehrkraft Dozent wird auf allen Kursterminen nur einmal übertragen oder mit dem geänderten\nFachlehrkraft aktualisiert!',
        distance: 'Wegstrecke (km)',
        lessonHour: 'UE (Unterrichtseinheiten)',
        lessonHourExceedsCourseHint: 'Zusammen mit den bereits verwendeten UE ergibt das {totalValue} und überschreitet die Kurs-UE ({courseValue}).',
        lessonHourExceedsCourseTitle: 'UE überschritten',
        lessonHourExceedsCourseMessage: 'Die eingegebene UE ({enteredValue}) zusammen mit der bereits verwendeten UE ({usedValue}) ergibt {totalValue} und überschreitet damit die Kurs-UE ({courseValue}). Trotzdem speichern?',
        lessonHourInfoCourseTotal: 'Gesamt UE im Kurs: {value} Einheiten',
        lessonHourInfoUsed: 'Andere (Termine/Dozenten): {value} Einheiten',
        payment: 'Vergütung (Euro)',
        paymentInfoLoading: 'Vergütung wird berechnet ...',
        paymentInfoEmpty: 'Keine Vergütungsberechnung verfügbar.',
        saveSuccess: 'Fachlehrkraft gespeichert.',
        saveError: 'Fachlehrkraft konnte nicht gespeichert werden.',
        otherCharge: 'Sonstiges (Euro)',
        otherChargeDesc: 'Bez.',
        surcharge: 'Zu-/Abschlag (Euro)',
        department: 'Abteilung',
        remark: 'Bemerkung'
      },
      deleteDialog: {
        title: 'Fachlehrkräfte entfernen',
        message: 'Sind Sie sicher, folgende Fachlehrkräfte vom Kurs zu entfernen?'
      },
      expandTitle: '{count} Termine',
      letters: {
        teacherCertificateTitle: 'Fachlehrkräfte mit dem Lehrschein für diesen Kurs',
        teacherCertificateTooltip: 'Fachlehrkräfte mit dem Lehrschein für diesen Kurs',
        noCertificates: 'Keine Fachlehrkräfte mit passendem Lehrschein vorhanden.',
        templatesTitle: 'Briefvorlagen für diesen Kurs',
        selectedTeachers: '{count} Fachlehrkräfte ausgewählt',
        selectedRecipients: 'Empfängerbasis: {count} Fachlehrkräfte'
      },
      columns: {
        surchargeEuro: 'Zu/Abschlag',
        otherEuro: 'sonstige',
        distance: 'Wegstrecke',
        rounded: 'abger.'
      }
    }
  },
  leftMenu: {
    toggle_menu: 'Menü ein-/ausblenden',
    customer_mask: 'Kundenmaske',
    customer_mask_search: 'Kundenmaskesuche',
    customer_list: 'Kundenliste',
    company_list: 'Firmenliste',
    customer_export: 'Kundenexport',
    customer_import: 'Kundenimport',
    letters_and_emails: 'Briefe & Mails',
    contact_form: 'Kontaktformular',
    resubmission: 'Wiedervorlage',
    bvw_import: 'BVW-Import',
    member_mask: 'Mitgliedermaske',
    member_mask_search: 'Mitgliedermaskesuche',
    list_of_members: 'Mitgliederliste',
    online_registration: 'Onlineanmeldung',
    sepa_export: 'SEPA-Export',
    member_import: 'Mitgliedsimport',
    member_export: 'Mitgliedsexport',
    statistic: 'Statistik',
    birthday: 'Geburtstage',
    anniversary_list: 'Jubiläumsliste',
    annual_receipt: 'Jahresquittungen',
    course_basic_settings: 'Kursgrundeinstellungen',
    course_overview: 'Kursübersicht',
    course_master_data: 'Kursstammdaten',
    lecturer_days: 'Fachlehrkrafttage',
    subscriber: 'Teilnehmer',
    course_documents: 'Kursunterlagen',
    course_dates: 'Kurstermine',
    course_materials: 'Kursmaterialien',
    lecturer: 'Fachlehrkräfte',
    subscriber_mask: 'Teilnehmermaske',
    subscriber_mask_search: 'Suche der Teilnehmer',
    subscriber_list: 'Teilnehmerliste',
    bg_list: 'BG-Liste',
    marketing_tool: 'Marketingtool',
    subscriber_import: 'Teilnehmerimport',
    course_import: 'Kursimport',
    invoice_journal: 'Rechnungsjournal',
    messages: 'Nachrichten'
  },
  news: {
    dialogTitle: 'Nachrichten',
    close: 'Schließen',
    empty: 'Keine Nachrichten vorhanden',
    defaultTitle: 'Neue Mitteilung',
    progress: '{percent} %',
    taskStatus: {
      scheduled: 'Geplant',
      queued: 'Wartet in Warteschlange',
      running: 'Läuft',
      succeeded: 'Erfolgreich abgeschlossen',
      failed: 'Fehlgeschlagen',
      cancelled: 'Abgebrochen',
      timeout: 'Zeitüberschreitung'
    },
    result: {
      mailSummary: '{succeeded} versendet, {failed} fehlgeschlagen',
      printSummary: '{succeeded} Dokumente erstellt',
      printFailed: '{failed} Dokumente konnten nicht erstellt werden',
      archiveFailed: 'Bei {archiveFailed} Ablagevorgängen sind Fehler aufgetreten.',
      failuresTitle: 'Fehler',
      download: 'PDF herunterladen',
      downloadFallbackName: 'Brief.pdf',
      fileUnavailable: 'Datei nicht mehr verfügbar',
      downloadError: 'Die Datei konnte nicht heruntergeladen werden.'
    }
  },
  queueTaskTrigger: {
    startError: 'Aktion konnte nicht gestartet werden.'
  },
  leftTopMenu: {
    user_database: 'Benutzerdatenbank',
    customer_database: 'Kundendatenbank',
    database: 'Datenbank',
    news: 'News',
    tutorial: 'Tutorial',
    help_customer_database: 'Hilfe Kundendatenbank',
    help_ktv: 'Hilfe KTV',
    help_fmv: 'Hilfe FMV',
    help_ktv_schools: 'Hilfe Akademie',
    faq_ktv: 'FAQ KTV',
    faq_privacy: 'FAQ Datenschutz',
    faq_ideas: 'FAQ Ideenwerkstatt',
    hotline_number: 'Hotlinenummer',
    service_database: 'Dienstleistungsdatenbank',
    drk_member_letter: 'DRK Mitgliederbrief',
    drk_internal: 'DRK Intern',
    purchase_portal: 'Einkaufsportal',
    help: 'Hilfe'
  },
  routes: {
    course_basic_settings: 'Einstellungs',
    letters_mails_breadcrumb: 'Briefe&Mails'
  },
  id: 'ID',
  area: 'Bereich',
  btn :{
    toCompany: 'Firma aufrufen',
    toZentrale: 'Zentrale aufrufen',
    save: 'Speichern',
    close: 'Schließen',
    apply: 'Übernehmen',
    copy: 'Kopieren',
    new: 'Neu',
    add: 'Hinzufügen',
    update: 'Aktualisieren',
    delete: 'Löschen',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    yes: 'Ja',
    no: 'Nein',
    logout: 'Abmelden'
  },
  courseSubscriber: {
    lettersTitle: 'Briefe als eMail/Druck',
    showLettersPanel: 'Briefe einblenden',
    hideLettersPanel: 'Briefe ausblenden',
    overview: 'Teilnehmerübersicht',
    filter: 'Filter',
    appearedCheckbox: {
      locked: 'Der Teilnehmer ist bereits abgerechnet, die Anwesenheit kann nicht mehr geändert werden.',
      saveError: 'Anwesenheit konnte nicht gespeichert werden.'
    },
    dialog: {
      addParticipant: 'Teilnehmer hinzufügen',
      addReservationParticipant: 'Teilnehmer der Reservierung',
      addReservation: 'Reservierung hinzufügen',
      editParticipant: 'Teilnehmer bearbeiten',
      editReservation: 'Reservierung bearbeiten',
      tabGeneral: 'Teilnehmer',
      openCustomerMask: 'Kundendatensatz öffnen',
      leaveCourseTitle: 'Kurs verlassen',
      leaveCourseMessage: 'Möchten Sie den Kurs verlassen und zum Kundendatensatz springen?',
      leaveCourseMessageCompany: 'Möchten Sie den Kurs verlassen und zum Firmendatensatz springen?',
      copyParticipantTitle: 'TN Kopie {current}/{total}',
      moveToCourse: 'Teilnehmer in Kurs verschieben/kopieren',
      priceChangeConfirmTitle: 'Teiln.-Gebühr wurde bereits mitgeteilt',
      priceChangeConfirmMessage: 'Der Teilnehmer wurde bereits über die Teiln.-Gebühr informiert (Online-Anmeldung mit Bezahlung). Soll die Gebühr trotzdem geändert werden?',
      priceChangeOldValue: 'Bisheriger Betrag',
      priceChangeNewValue: 'Neuer Betrag'
    },
    deleteReservation: {
      title: 'Reservierung löschen',
      message: 'Möchten Sie die Reservierung entfernen?',
      success: 'Reservierung wurde gelöscht',
      error: 'Reservierung konnte nicht gelöscht werden'
    },
    deleteDialog: {
      title: 'Teilnehmer löschen',
      message: 'Möchten Sie wirklich folgende Teilnehmer löschen?',
      success: 'Teilnehmer erfolgreich gelöscht',
      error: 'Teilnehmer konnten nicht gelöscht werden',
      headers: {
        lastname: 'Name',
        firstname: 'Vorname',
        city: 'Stadt',
        email: 'E-Mail'
      }
    },
    statusReasons: {
      waitlist: {
        full: 'Kurs ausgebucht',
        requirements: 'Voraussetzungen nicht erfüllt',
        releasePending: 'Freigabe ausstehend'
      },
      declined: {
        full: 'Kurs ausgebucht',
        qualification: 'Fehlende Qualifikation',
        releaseDenied: 'Freigabe nicht erteilt'
      },
      unsubscribed: {
        illness: 'Krankheit',
        association: 'Verband'
      }
    },
    actions: {
      moreOptions: 'Weitere Optionen',
      notAvailable: 'Funktion noch nicht verfügbar',
      close: 'Schließen',
      menu: {
        moveToCourse: 'Teiln. in Kurs verschieben',
        copyParticipants: 'Teiln. kopieren',
        moveToWaitlist: 'Teiln. zu Warteliste',
        moveToDeclined: 'Teiln. zu Abgelehnt',
        moveToUnsubscribed: 'Teiln. zu Abgemeldet',
        moveToParticipants: 'Teiln. zu Teilnehmerliste',
        markAppeared: 'Als erschienen markieren',
        delete: 'Teiln. löschen',
        deleteReservation: 'Reserv. löschen'
      },
      confirm: {
        moveToWaitlist: {
          title: 'Teilnehmer zu Warteliste übergeben',
          message: 'Möchten Sie wirklich folgende Teilnehmer zur Warteliste verschieben?',
          success: 'Teilnehmer erfolgreich zur Warteliste verschoben',
          error: 'Teilnehmer konnten nicht zur Warteliste verschoben werden'
        },
        moveToUnsubscribed: {
          title: 'Teilnehmer zu Abgemeldet übergeben',
          message: 'Möchten Sie wirklich folgende Teilnehmer zu Abgemeldet verschieben?',
          success: 'Teilnehmer erfolgreich zu Abgemeldet verschoben',
          error: 'Teilnehmer konnten nicht zu Abgemeldet verschoben werden'
        },
        moveToDeclined: {
          title: 'Teilnehmer zu Abgelehnt übergeben',
          message: 'Möchten Sie wirklich folgende Teilnehmer zu Abgelehnt verschieben?',
          success: 'Teilnehmer erfolgreich zu Abgelehnt verschoben',
          error: 'Teilnehmer konnten nicht zu Abgelehnt verschoben werden'
        },
        moveToParticipants: {
          title: 'Teilnehmer zu Teilnehmerliste übergeben',
          message: 'Möchten Sie wirklich folgende Teilnehmer zur Teilnehmerliste verschieben?',
          success: 'Teilnehmer erfolgreich zur Teilnehmerliste verschoben',
          error: 'Teilnehmer konnten nicht zur Teilnehmerliste verschoben werden'
        },
        markAppeared: {
          title: 'Teilnehmer als erschienen markieren',
          message: 'Möchten Sie wirklich folgende Teilnehmer als erschienen markieren?',
          success: 'Teilnehmer erfolgreich als erschienen markiert',
          error: 'Teilnehmer konnten nicht als erschienen markiert werden'
        }
      }
    },
    filters: {
      bg: 'BG'
    },
    dateFrom: 'Von',
    dateTo: 'Bis',
    messages: {
      saveSuccess: 'Datensatz gespeichert',
      saveError: 'Datensatz konnte nicht gespeichert werden',
      selectSingleReservation: 'Bitte genau eine Reservierung auswählen.'
    },
    wizard: {
      confirmDuplicateTitle: 'Dublettenhinweis',
      confirmMasterDataOverwriteMessage: 'Dieser Kunde existiert schon mit abweichenden Stammdaten. Beim Speichern werden seine Stammdaten mit den eingegebenen Daten überschrieben. Trotzdem speichern?',
      alreadyInCourseMessage: 'Dieser Kunde existiert schon in diesem Kurs.',
      noAdditionalFields: 'Für dieses Modul sind keine Zusatzinformationen verfügbar.',
      savedSuccess: 'Teilnehmer erfolgreich gespeichert',
      savedError: 'Teilnehmer konnte nicht gespeichert werden',
      steps: {
        master: 'Stammdaten',
        courseData: 'Zahlungsdaten',
        billingAddress: 'Rechnungsadresse',
        additional: 'Zusatzinformationen',
        summary: 'Zusammenfassung'
      }
    },
    reservationWizard: {
      confirmSaveTitle: 'Reservierung speichern',
      confirmSaveMessage: 'Soll die neue Reservierung gespeichert werden?',
      savedSuccess: 'Reservierung erfolgreich gespeichert',
      savedError: 'Reservierung konnte nicht gespeichert werden',
      steps: {
        company: 'Firma',
        reservation: 'Reservierungsdaten',
        notes: 'Bemerkungen',
        summary: 'Zusammenfassung'
      }
    },
    moveDialog: {
      sourceTitle: 'Teilnehmer des aktuellen Kurses',
      targetTitle: 'Zielkurse',
      search: 'Suchen',
      reset: 'Zurücksetzen',
      modeLabel: 'Aktion',
      dragHint: 'Per Drag&Drop auf einen Zielkurs verschieben oder kopieren.',
      dragSelectionLabel: 'Ausgewählte Teilnehmer:',
      dragPreview: {
        moveTitle: 'Verschieben der Teilnehmer',
        copyTitle: 'Kopieren der Teilnehmer'
      },
      confirm: {
        moveTitle: 'Teilnehmer verschieben',
        copyTitle: 'Teilnehmer kopieren',
        moveMessage: 'Sollen die folgenden Teilnehmer wirklich in den Zielkurs verschoben werden?',
        copyMessage: 'Sollen die folgenden Teilnehmer wirklich in den Zielkurs kopiert werden?',
        targetLabel: 'Zielkurs',
        moveAction: 'Verschieben',
        copyAction: 'Kopieren'
      },
      noSourceRows: 'Keine Teilnehmer vorhanden.',
      noTargetRows: 'Keine Zielkurse gefunden.',
      loadingTargets: 'Zielkurse werden geladen...',
      modes: {
        move: 'verschieben',
        copy: 'kopieren'
      },
      fields: {
        internalName: 'Kursnr.',
        eventName: 'Kursbez.',
        from: 'Kurs von',
        to: 'bis',
        onlyFreePlaces: 'Plätze > 0'
      },
      columns: {
        participant: 'Teilnehmer',
        reason: 'Grund',
        lastname: 'Name',
        firstname: 'Vorname',
        city: 'Ort',
        email: 'E-Mail',
        eventName: 'Kursbez.',
        internalName: 'Kursnr.',
        location: 'Kursort',
        dateRange: 'von/bis',
        freeSeats: 'Plätze',
        status: 'Status'
      },
      notifications: {
        missingSelection: 'Bitte zuerst mindestens einen Teilnehmer auswählen.',
        missingDropRows: 'Es wurden keine Teilnehmer für den Transfer erkannt.',
        sameCourse: 'Quellkurs und Zielkurs sind identisch.',
        searchError: 'Zielkurse konnten nicht geladen werden.',
        transferError: 'Teilnehmer konnten nicht übertragen werden.',
        moveSuccess: 'Teilnehmer erfolgreich verschoben.',
        copySuccess: 'Teilnehmer erfolgreich kopiert.'
      }
    },
    tabs: {
      reservations: 'Reservierung',
      declined: 'Abgelehnt',
      unsubscribed: 'Abgemeldet'
    },
    columns: {
      bgShort: 'BG TN',
      places: 'Plätze',
      payerType: 'Kategorie',
      reservationDate: 'Reservierungsdatum',
      statusChangeDate: 'Abmeldedatum',
      appeared: 'Erschienen',
      appearedShort: 'Ersch.'
    },
    fields: {
      payerType: 'Kategorie',
      bgRecipient: 'Berufsgenossenschaft (Rechnungsempfänger)',
      bgRecipientNoCompany: 'Für BG-Teilnehmer bitte eine Firma auswählen – die Berufsgenossenschaft wird aus der Firma abgeleitet.',
      bgRecipientMissing: 'Bei dieser Firma ist keine Berufsgenossenschaft hinterlegt – es kann keine BG-Rechnung erstellt werden.',
      bgCompanyRequired: 'Für BG-Teilnehmer muss eine Firma aus der Liste ausgewählt werden.',
      appeared: 'Erschienen',
      billingType: 'Abrechnung',
      billingPractice: 'Praxen und Firmen',
      billingBg: 'BG Teilnehmer',
      payment: 'Teiln.-Gebühr',
      paymentTooltip: '- Teiln.-Gebühr kann manuell verändert werden.\n- wenn kein Pauschalbetrag in den Kursstammdaten hinterlegt wurde, wird der Betrag von den Kurs-Grundeinstellungen übernommen\n- wird der Radiobutton "BG Teilnehmer" aktiviert gilt der Teiln.-Gebühr der Allgem. "Vereinsdaten" vom BG-Satz.',
      reduction: 'Ermäßigung',
      noReduction: 'keine Ermäßigung',
      department: 'Abteilung',
      onlineRegistration: 'Onl.-Anmeld.',
      onlineRegistrationTooltip: 'Datum der Kurs-Onlineanmeldung',
      reservationDate: 'Reservierungsdatum',
      reservationLink: 'Reservierungslink',
      reservationTooltipPrefix: 'Reservierung zu Teiln. vom',
      openReservationLink: 'Link öffnen',
      freeSeatsContext: 'Freie Plätze',
      reservedParticipants: 'Res. Teiln.',
      reservationTotal: 'Res. Sum.',
      module: 'Module',
      moduleTooltip: 'Kunden die dem FMV-Modul zugeordnet sind können nur in der Fördermitgliedsverwaltung bearbeitet werden!',
      company: 'Firma',
      companyOptionDebtorNumber: 'Deb.-Nr. {number}',
      // KDB-2194: renamed "Ansprechpartner" to "Ansprechperson"
      contactPerson: 'Ansprechperson',
      remark: 'Bemerkung',
      internalNotice: 'Notiz (intern)',
      paypalId: 'PayPal-ID',
      paypalTransactionNumber: 'Transaktionsnr.',
      paypalPayerTooltip: 'Die PayPal-Zahlung stammt vom Rechnungsempfänger, nicht vom Teilnehmer.',
      statusTn: 'Status TN',
      feeType: 'Kostenart',
      feeTypeInternal: 'Intern',
      feeTypeExternal: 'Extern',
      feeTypeHik: 'HIK'
    },
    extra: {
      courseData: 'Kursdaten',
      billingAddress: 'Rechnungsadresse',
      paymentData: 'Zahlungsdaten',
      invoiceRecipient: 'Rechnungsempfänger',
      editInvoiceRecipient: 'alternative Rechnungsempfänger',
      additionalData: 'Zusatzinformationen',
      dog: 'Hund',
      dogSex: 'Geschlecht',
      dogBadge: 'Kennung',
      dogBirthday: 'Wurfdatum',
      dogChipnumber: 'Chipnummer',
      dogBreeding: 'Rasse',
      dogTesteeType: 'Prüflingsstatus',
      reservation_room: 'Hotelzimmer',
      subscriberUnits: 'Teiln.-UE',
      contactPerson: 'Ansprechp.',
      orderCode: 'Bestellnr.',
      food: 'Essensauswahl',
      qualification: 'Qualifikation',
      honorary: 'Ehrenamt',
      member: 'Mitglied',
      health_risks: 'Ges. Risiken',
      children: 'Teilnahme der Kinder',
      childSelection: 'Kinder',
      parentRelation: 'Bez. Eltern',
      childOne: 'Kind 1',
      childTwo: 'Kind 2',
      optional: 'optional',
      childAgeTooltip: 'Das Kind ist {ageYears} Jahre und {ageMonths} Monate alt.',
      childAgeWarningTooltip: 'Zum Kursdatum ist das Kind älter als {limitYears} Jahre und {limitMonths} Monate.',
      showAdditionalInformation: 'Zusatzinformationen anzeigen',
      hideAdditionalInformation: 'Zusatzinformationen ausblenden',
      no_data: 'Keine Daten',
    },
    legend: {
      title: 'Legende',
      reservation: 'Teilnehmer aus Reservierung',
      childAgeWarning: 'Kind vom Teiln. ist älter als 15 Jahre und 6 Monate'
    }
  },
  courseDocuments: {
    lettersTitle: 'Briefe als eMail/Druck',
    selfPayer: 'Selbstzahler',
    tabs: {
      participants: 'Teilnehmer',
      teachers: 'Fachlehrkräfte',
      documents: 'Dokumente'
    },
    viewGroups: 'Empfänger/Firmen/SZ',
    viewAllParticipants: 'Alle Teilnehmer',
    participantsTitle: 'Teilnehmer',
    archiveTitle: 'Archiv',
    participantsGroup: 'Firma / Selbstzahler',
    // KDB-2194: renamed "Ansprechpartner" to "Ansprechperson"
    contactPerson: 'Ansprechperson',
    participantCount: 'TN',
    bgCount: 'BG',
    archiveLetterName: 'letzte gedruckte Briefe',
    archiveSentBy: 'Versendet von',
    archiveDate: 'Datum',
    archiveReceiver: 'Empfänger',
    unknownCompany: 'Firma (unbekannt)',
    noGroups: 'Keine Teilnehmer vorhanden.',
    noHistory: 'Keine Daten vorhanden.',
    downloadLetter: 'Datei herunterladen',
    downloadError: 'Datei konnte nicht heruntergeladen werden.',
    historyErrors: {
      title: 'Folgende Fehler sind aufgetreten:',
      recipient: 'Fehler für {name}: {error}',
      bundle: 'Fehler beim Zusammenführen: {error}',
      downloadHint: 'Klicken, um die Fehler als CSV herunterzuladen.'
    },
    documentsTitle: 'Dokumente',
    documentName: 'Dokument',
    documentComment: 'Bemerkung',
    documentUploadDate: 'hochgeladen am',
    noDocuments: 'Keine Dokumente vorhanden.',
    uploadDocument: 'Dokument hochladen',
    uploadDialogTitle: 'Dokument hochladen',
    uploadFile: 'Datei auswählen',
    uploadErrorCourse: 'Bitte zuerst einen Kurs auswählen.',
    deleteConfirmMessage: 'Dokument wirklich löschen?',
    downloadDocumentError: 'Dokument konnte nicht heruntergeladen werden.'
  },
  courseBilling: {
    showCashBalance: 'Kassenbestand einblenden',
    hideCashBalance: 'Kassenbestand ausblenden',
    legend: {
      title: 'Abrechnungsstatus',
      notBillable: 'Keine Abrechnung',
      notAppeared: 'nicht erschienen',
      settled: 'Bar, PayPal oder Rechnung gebucht',
      invoiceDraft: 'Rechnung im Journal, noch nicht verbucht',
      unsettled: 'offen'
    },
    tabs: {
      recipients: 'Rechnungsempfänger',
      unsubscribed: 'Abgemeldet'
    },
    columns: {
      lastname: 'Name',
      firstname: 'Vorname',
      companyName: 'Firma',
      bereich: 'Bereich',
      invoiceRecipient: 'Rechnungsempfänger',
      status: 'Status',
      unsubscriberRng: 'Rng.',
      paymentMethod: 'Zahlungsart',
      additionalInvoice: 'Zusatzrechnung'
    },
    settledInfo: {
      invoiceNumber: 'Re-Nr.',
      who: 'Wer',
      what: 'Was',
      when: 'wann',
      recipient: 'Rechnungsempfänger',
      iban: 'IBAN',
      noIban: 'keine IBAN hinterlegt'
    },
    noRecipients: 'Keine Rechnungsempfänger vorhanden.',
    noUnsubscribed: 'Keine Abmeldungen vorhanden.',
    loadError: 'Daten konnten nicht geladen werden.',
    status: {
      unsettled: 'offen',
      reservation: 'Reservierung',
      invoice_draft: 'Rechnung im Journal, nicht verbucht',
      invoice_booked: 'Rechnung verbucht',
      settled: 'abgerechnet',
      settled_cash: 'abgerechnet (Bar)',
      settled_paypal: 'abgerechnet (PayPal)',
      not_billable: 'keine Abrechnung',
      not_appeared: 'nicht erschienen',
      partiallyInvoiced: 'teilweise in Rechnung ({invoiced} von {total})'
    },
    reservation: {
      flag: 'Reservierung',
      flagWithPlaces: 'Reservierung: {count} Pl.',
      places: '{count} Plätze'
    },
    notAppearedTooltip: 'Teilnehmer wurde nicht als erschienen markiert und kann daher nicht abgerechnet werden.',
    bgRecipientMissingTooltip: 'BG-Teilnehmer ohne Berufsgenossenschaft: Firma fehlt oder hat keine BG hinterlegt. Es kann keine BG-Rechnung erstellt werden.',
    buttons: {
      generateTeacherInvoice: 'Abrechnung DZ',
      generateCourseInvoice: 'Abrechnung Kurs',
      invoiceAllParticipants: 'Rechnungen für offene Teilnehmer erstellen',
      invoiceAllParticipantsTooltip: 'Rechnungen für offene Teilnehmer erstellen – je erschienenem, noch nicht abgerechnetem Teilnehmer eine Rechnung ins Rechnungsjournal',
      generateCourseInvoiceTooltip: 'Abrechnung Kurs – Kursabrechnung als PDF erstellen',
      generateTeacherInvoiceTooltip: 'Abrechnung DZ – Dozentenabrechnung als PDF erstellen',
      settle: 'Abgerechnet',
      settleTooltip: 'Abgerechnet – Zahlungsart wählen (Bar, PayPal, keine Abrechnung, Rechnung)',
      success: 'Erfolgreich gespeichert',
      error: 'Aktion konnte nicht ausgeführt werden',
      notYetAvailable: 'Noch nicht verfügbar – erzeugt im Altsystem direkt ein PDF aus einer Vorlage; die Vorlage muss dafür erst neu gebaut werden (Folgearbeit)'
    },
    moreActions: 'Weitere Aktionen',
    bgGroupInvoice: {
      menuLabel: 'alle BG gruppiert abrechnen',
      title: 'Alle BG gruppiert abrechnen',
      hint: 'Je Berufsgenossenschaft wird eine BG-Rechnung über die ausgewählten Teilnehmer ins Rechnungsjournal übernommen. Abgewählte Teilnehmer bleiben offen.',
      noParticipants: 'Keine offenen BG-Teilnehmer vorhanden.',
      selectedCount: '{count} von {total} Teilnehmern ausgewählt',
      loading: 'BG-Rechnungen werden erstellt …',
      created: '{invoices} BG-Rechnung(en) für {participants} Teilnehmer ins Rechnungsjournal übernommen.',
      createdWithSkipped: '{invoices} BG-Rechnung(en) für {participants} Teilnehmer ins Rechnungsjournal übernommen, {skipped} Teilnehmer übersprungen (nicht mehr offen).',
      createError: 'BG-Rechnungen konnten nicht erstellt werden.'
    },
    additionalInvoiceConfirm: {
      title: 'Zusatzrechnung erstellen',
      message: 'Achtung: Es existiert bereits ein Rechnungsdatensatz im Rechnungsjournal. Trotzdem eine Zusatzrechnung erstellen?',
      ok: 'Zusatzrechnung erstellen'
    },
    previewDialog: {
      internalGroup: 'Mitarbeiter (intern)',
      invoiceCount: '{count} Rechnung(en)',
      bgGroupPrefix: 'BG:',
      companyGroupPrefix: 'Firma:',
      titleTeacher: 'Vorschau / Abrechnung DZ',
      titleCourse: 'Vorschau / Abrechnung Kurs',
      titleParticipant: 'Vorschau / Empfänger',
      titleAll: 'Vorschau / alle TN',
      titleCompany: 'Vorschau / Firma {company}',
      titleReservation: 'Vorschau / Reservierung {company}',
      recipient: 'Empfänger',
      description: 'Bezeichnung',
      quantity: 'Anzahl',
      unitPrice: 'Einzelbetrag',
      amount: 'Betrag',
      total: 'Gesamt',
      noItems: 'Keine Posten vorhanden.',
      confirm: 'Daten ins Rechnungsjournal übernehmen',
      cancel: 'Abbrechen',
      totalLong: '(Kurs Summe + Posten) Gesamt Brutto:',
      totalSuffix: 'Euro',
      loadError: 'Vorschau konnte nicht geladen werden.',
      tnList: {
        title: 'Teilnehmerliste',
        firstname: 'Vorname',
        lastname: 'Name',
        amount: 'Betrag',
        courseNumber: 'Kurs-Nr.',
        revenueAccount: 'Erlöskonto',
        zip: 'PLZ',
        city: 'Ort',
        street: 'Straße',
        phone: 'Telefon',
        reduction: 'Ermäßigung'
      },
      header: {
        title: 'Empfänger & Rechnungsdaten',
        prefix: 'Anrede',
        titel: 'Titel',
        apName: 'Ansprechpartner',
        org2: 'Firma (Zusatz)',
        bgZusatz: 'Abrechnungsstelle',
        compName: 'BG-Firma',
        street: 'Straße',
        additional: 'Adresszusatz',
        zip: 'PLZ',
        city: 'Ort',
        mail: 'E-Mail',
        bookingDate: 'Buchungsdatum',
        createdDate: 'Erstelldatum',
        debKonto: 'Debitoren-Nr.',
        eventName: 'Kursbezeichnung',
        internalName: 'Kurs-Nr.',
        eventFromDate: 'Kurs von',
        eventToDate: 'Kurs bis',
        costCenter: 'Kostenstelle',
        revenueAccount: 'Erlöskonto',
        indivCode: 'Indiv. Code',
        costDocumentNumber: 'Kostenzus. Belegnr.',
        memberNumber: 'Unternehmernr.',
        invoiceNumber: 'Rechnungsnummer',
        tnAnzahl: 'TN-Anzahl',
        mwst: 'MwSt.',
        kursSumme: 'Kurs Summe'
      },
      items: {
        title: 'Posten',
        addItem: 'Posten hinzufügen',
        revenueAccount: 'Erlöskonto',
        costCenter: 'Kostenstelle',
        description: 'Bezeichnung',
        quantity: 'Anzahl',
        unitPrice: 'Einzelbetrag',
        mwst: 'MwSt.'
      }
    },
    freeInvoice: {
      title: 'Freie Rechnung / Gutschrift',
      tab: 'Zusatzrechnung',
      kindInvoice: 'Rechnung',
      kindCreditNote: 'Gutschrift',
      customerData: 'Kundendaten',
      customerSearch: 'Kundensuche',
      noResults: 'Keine Treffer',
      name: 'Name',
      invoiceAddress: 'Rechnungsadresse',
      courseData: 'Kurs & Buchung',
      costType: 'Kostenart',
      totalItems: '(Posten) Gesamt Brutto:',
      noRecipient: 'Bitte einen Rechnungsempfänger auswählen.',
      noItems: 'Bitte mindestens einen Posten erfassen.',
      created: 'Daten wurden ins Rechnungsjournal übernommen.'
    },
    newItem: 'Neuer Posten',
    journal: {
      title: 'Rechnungsjournal',
      noEntries: 'Noch keine Rechnungen vorhanden.',
      downloadTooltip: 'Rechnung herunterladen',
      columns: {
        invoiceNumber: 'Rechnungsnummer',
        type: 'Typ',
        bookingStatus: 'Status',
        recipient: 'Empfänger',
        amount: 'Betrag',
        date: 'Datum'
      },
      bookingStatus: {
        draft: 'Rechnungsdaten',
        booked: 'Gebuchte Rechnung'
      },
      types: {
        dz_abrechnung: 'Abrechnung DZ',
        kurs_abrechnung: 'Abrechnung Kurs',
        tn_sammel: 'Sammelrechnung TN',
        tn_einzel: 'Rechnung TN',
        rechnung_bg: 'Rechnung BG',
        tn_zusatzrechnung: 'Zusatzrechnung TN',
        gutschrift: 'Gutschrift',
        freie_rechnung: 'freie Rechnung',
        freie_gutschrift: 'freie Gutschrift',
        sammelrechnung: 'Sammelrechnung',
        ausfallrechnung: 'Ausfallrechnung',
        verworfen: 'Verworfene Rechnungsdaten',
        sonstige: 'Sonstige'
      }
    },
    cashBalance: {
      title: 'Buchhaltung',
      subtitle: 'Kassenbestand',
      income: 'Einnahmen',
      expenses: 'Ausgaben',
      resultTotal: 'Ergebnis gesamt',
      incomeTotal: 'Einnahmen gesamt',
      expensesTotal: 'Ausgaben gesamt',
      participant: 'Teilnehmer',
      participantCount: 'TN Anzahl',
      sum: 'Summe',
      rows: {
        selbstzahler: 'Selbstzahler',
        firmen_praxen: 'Firmen & Praxen',
        bg_teilnehmer: 'BG-Teilnehmer',
        nicht_erschienen: 'nicht erschienen',
        abgemeldet: 'Abgemeldet',
        keine_abrechnung: 'keine Abrechnung',
        max_summe_tn_gebuehren: 'max. Summe TN-Gebühren',
        nicht_abgerechnet: 'nicht abgerechnet',
        material: 'Kursmaterialien',
        subscriberMaterial: 'Teilnehmermaterialien',
        teacher: 'Ausbildervergütung'
      },
      hints: {
        selbstzahler: 'Teilnehmergebühren aller Selbstzahler (ohne Abgemeldete), unabhängig vom Abrechnungsstand',
        firmen_praxen: 'Teilnehmergebühren aller Firmen- und internen Teilnehmer (ohne Abgemeldete), unabhängig vom Abrechnungsstand',
        bg_teilnehmer: 'Teilnehmergebühren aller BG-Teilnehmer (ohne Abgemeldete), unabhängig vom Abrechnungsstand',
        max_summe_tn_gebuehren: 'Summe der Teilnehmergebühren aller angemeldeten Teilnehmer (ohne Abgemeldete)',
        nicht_erschienen: 'Teilnehmer, die nicht als erschienen markiert sind – werden von den Einnahmen abgezogen',
        abgemeldet: 'Abgemeldete Teilnehmer – zählen nicht zu den Einnahmen',
        keine_abrechnung: 'Erschienene Teilnehmer mit „keine Abrechnung“ – werden von den Einnahmen abgezogen',
        nicht_abgerechnet: 'Erschienene Teilnehmer ohne Abrechnung (weder Bar, PayPal, Rechnung noch keine Abrechnung) – werden von den Einnahmen abgezogen'
      }
    },
    settleDialog: {
      title: 'Abgerechnet',
      paymentMethod: 'Zahlungsart',
      open: 'offen',
      cash: 'Bar',
      paypal: 'PayPal',
      none: 'keine Abrechnung',
      invoice: 'Rechnung',
      paypalTransactionId: 'PayPal-Transaktions-ID',
      paypalInvoiceNumber: 'PayPal-Rechnungsnummer',
      paypalPayerEmail: 'PayPal-Zahler-E-Mail',
      paypalPaidAt: 'Bezahlt am',
      paypalNotice: 'Notiz (PayPal)',
      notice: 'Notiz',
      invoiceHint: 'Nach dem Speichern wird die Rechnung in der Vorschau angezeigt und kann ins Rechnungsjournal übernommen werden.',
      saveError: 'Abrechnung konnte nicht gespeichert werden.',
      saved: 'Abrechnung gespeichert'
    },
    history: {
      title: 'Protokoll',
      empty: 'Keine Einträge vorhanden.',
      unknownUser: 'Unbekannter Benutzer'
    }
  },
  annualReceipt: {
    title: 'Jahresquittungen',
    filters: {
      year: 'für das Jahr',
      clientType: 'Firma/Person',
      person: 'Person',
      company: 'Firma',
      name: 'Name',
      customerNumber: 'Mitgliedsnr.',
      service: 'Mitgliedsbez.',
      relationStatus: 'Bez.status',
      acknowledgment: 'Jahresquittung',
      repatriation: 'Rückholdienst',
      localAssociation: 'Ortsverein',
      localAssociationNone: 'keiner',
      addressStatus: 'Adressstatus',
      notice: 'Notiz',
      amountFrom: 'Zahlung von',
      amountTo: 'bis',
      showReceipted: 'bereits quittierte anzeigen'
    },
    columns: {
      customerNumber: 'Kundennummer',
      name: 'Name',
      acknowledgment: 'Jahresquittung',
      paymentCount: 'Buchungen',
      amount: 'Betrag'
    },
    summary: '{count} Kunden, Gesamtbeträge {amount}',
    loadError: 'Die Jahresquittungen konnten nicht geladen werden.',
    removeReceipt: {
      tooltip: 'Quittierung entfernen',
      title: 'Quittierung entfernen',
      message: 'Sind Sie sicher, dass Sie die Quittierung(en) von „{name}“ für {year} wirklich entfernen möchten?',
      cancel: 'Abbrechen',
      success: 'Die Quittierung wurde entfernt.',
      error: 'Die Quittierung konnte nicht entfernt werden.'
    },
    dispatch: {
      titlePrint: 'Zuwendungsbestätigungen drucken',
      titleMail: 'Zuwendungsbestätigungen mailen',
      letter: 'Brief',
      scopeSelected: 'Ausgewählte Mitglieder ({count})',
      scopeAll: 'Alle Treffer ({count})',
      originalHint: 'Die Zuwendungsbestätigungen für {year} werden als Original erstellt. Die aufgeführten Beiträge werden quittiert, sobald der Versand an das Mitglied erfolgreich war.',
      copyHint: 'Die Beiträge sind bereits quittiert: die Zuwendungsbestätigungen für {year} werden als Kopie erstellt.',
      print: 'Drucken',
      mail: 'Mailen',
      filename: 'Zuwendungsbestaetigungen_{year}.pdf',
      queued: 'Der Auftrag wurde gestartet. Fortschritt und Ergebnis finden Sie unter "Nachrichten".',
      error: 'Der Versand konnte nicht gestartet werden.'
    }
  },
  invoiceJournal: {
    dispatch: {
      empty: 'Keine Einträge',
      mailed: 'Rechnung als E-Mail versendet',
      printed: 'Rechnung ausgedruckt',
      exported: 'Rechnung als Datei exportiert',
      tabs: { amounts: 'Beträge', dispatch: 'Versand' },
      columns: { date: 'Datum', time: 'Uhrzeit', mail: 'E-Mail-Adresse', name: 'Name', letter: 'Briefvorlage', user: 'Benutzer', lastExport: 'Zuletzt exportiert am' }
    },
    creditNoteFor: 'Gutschrift zu {number}',
    courseJump: {
      open: 'Kurs öffnen',
      confirm: 'Der Kurs {number} wird geöffnet. Möchten Sie fortfahren?'
    },
    sellerData: {
      title: 'Organisationsdaten',
      missing: 'Pflichtangabe für die E-Rechnung fehlt',
      menuMissing: 'Für die E-Rechnung fehlt:',
      missingHint: 'Für die E-Rechnung fehlen {count} Pflichtangaben. Sie sind unten rot markiert.',
      openAssociationData: 'Vereinsdaten öffnen',
      openAssociationDataConfirm: 'Die Vereinsdaten werden in einer neuen Seite geöffnet. Möchten Sie fortfahren?',
      loadError: 'Die Organisationsdaten konnten nicht geladen werden.',
      groups: {
        organisation: 'Organisation',
        association: 'Steuerangaben',
        bank: 'Bankverbindung',
        contact: 'Sachbearbeiter'
      },
      maintainedIn: {
        organisation: 'Kann in der Benutzerverwaltung (Organisationsdaten) hinzugefügt oder geändert werden, die Ebene in den Vereinsdaten.',
        association: 'Kann in den Vereinsdaten hinzugefügt oder geändert werden.',
        bank: 'Kann in den Vereinsdaten (Hauptbank des Moduls) hinzugefügt oder geändert werden.',
        contact: 'Kann in der Benutzerverwaltung hinzugefügt oder geändert werden.'
      },
      fields: {
        organisation: { level: 'Ebene', name: 'Name', street: 'Straße', zipcode: 'Postleitzahl', city: 'Ort', phone: 'Telefon', email: 'E-Mail' },
        association: { sales_tax: 'USt-IdNr.', tax_number: 'Steuernummer' },
        bank: { iban: 'IBAN', bic: 'BIC' },
        contact: { name: 'Name', phone: 'Telefon', email: 'E-Mail' }
      }
    },
    collectiveInvoice: {
      selection: 'Auswahl',
      dateFrom: 'Kurszeitraum von',
      dateTo: 'bis',
      invalidDate: 'Bitte ein gültiges Datum (TT.MM.JJJJ) eingeben.',
      dateToBeforeFrom: 'Das Datum „bis“ darf nicht vor „von“ liegen.',
      payer: {
        bg: 'Berufsgenossenschaft',
        company: 'Firma'
      },
      payerOption: '{label} ({count} TN)',
      noPayers: {
        bg: 'Im gewählten Zeitraum hat keine Berufsgenossenschaft offene Teilnehmer.',
        company: 'Im gewählten Zeitraum hat keine Firma offene Teilnehmer.'
      },
      hint: {
        bg: 'Berücksichtigt werden nur erschienene, noch nicht abgerechnete Teilnehmer, deren Firma die gewählte Berufsgenossenschaft hinterlegt hat.',
        company: 'Berücksichtigt werden nur erschienene, noch nicht abgerechnete Teilnehmer der gewählten Firma (ohne BG-Teilnehmer).'
      },
      noParticipants: 'Keine Teilnehmer vorhanden, daher kann keine Rechnung erstellt werden!',
      create: 'Ins Rechnungsjournal übernehmen',
      created: 'Die Sammelrechnung wurde ins Rechnungsjournal übernommen.',
      createdWithSkipped: 'Die Sammelrechnung wurde ins Rechnungsjournal übernommen. {count} Teilnehmer waren nicht mehr offen und wurden nicht berücksichtigt.',
      createError: 'Die Sammelrechnung konnte nicht erstellt werden.'
    },
    interfaceExport: {
      title: 'Schnittstellenexport – {type}',
      tabs: {
        exports: 'Exporte',
        settings: 'Einstellungen'
      },
      start: 'Export starten',
      startAction: '{type} exportieren',
      scopeSelected: 'Ausgewählte Rechnungen ({count})',
      scopeAll: 'Alle noch nicht exportierten Rechnungen der aktuellen Filterung',
      unsavedSettings: 'Die Einstellungen haben ungespeicherte Änderungen. Der Export verwendet erst die gespeicherten Einstellungen.',
      history: 'Verlauf',
      historyEmpty: 'Noch keine Exporte vorhanden.',
      download: 'Herunterladen',
      delete: 'Exportdatei löschen',
      deleteConfirm: 'Exportdatei „{name}“ wirklich löschen?',
      columns: {
        created: 'Datum',
        filename: 'Datei',
        user: 'Benutzer',
        size: 'Größe'
      },
      messages: {
        created: 'Export wurde erstellt ({count} Rechnungen).',
        createError: 'Der Export konnte nicht erstellt werden.',
        historyError: 'Der Exportverlauf konnte nicht geladen werden.',
        downloadError: 'Die Exportdatei konnte nicht heruntergeladen werden.',
        deleted: '{name} wurde gelöscht.',
        deleteError: 'Die Exportdatei konnte nicht gelöscht werden.'
      }
    },
    tabs: {
      unbooked: 'Nicht gebucht',
      archiveRecent: 'Gebucht 0-2 Jahre',
      archiveOld: 'Archiv + 2 Jahre'
    },
    subTabs: {
      overview: 'Übersicht',
      booking: 'Verbuchen',
      singleInvoice: 'Einzelrechnung'
    },
    filters: {
      invoiceNumber: 'Rechnungsnummer',
      type: 'Abrechnungstyp',
      debtorNumber: 'Debitorennummer',
      courseNumber: 'Kursnummer',
      moreFilters: 'Weitere Filter',
      dateFrom: 'Buchung von',
      dateTo: 'Buchung bis'
    },
    list: {
      title: 'Nicht gebuchte Rechnungen',
      empty: 'Keine nicht gebuchten Rechnungen vorhanden.'
    },
    groups: {
      invoice: 'Rechnung',
      recipient: 'Empfänger',
      course: 'Kurs',
      internal: 'Intern',
      booked: 'Verbucht'
    },
    columns: {
      invoiceNumber: 'R.-Nr.',
      mailTo: 'Mail an',
      printed: 'Druck',
      exported: 'Export',
      exportDate: 'Exportdatum',
      bookedBy: 'Bearbeiter',
      type: 'Typ',
      created: 'Erstellung',
      bookingDate: 'Buchung',
      debtorNumber: 'DebitorNr.',
      recipient: 'Rechnungsempfänger',
      category: 'Kat.',
      courseNumber: 'KursNr.',
      courseTitle: 'Kursbezeichnung',
      participants: 'TN',
      total: 'Summe',
      courseStart: 'Kurs von',
      courseEnd: 'Kurs bis',
      costCenter: 'Kostenst.',
      revenueAccount: 'Sachkonto',
      lastName: 'Name',
      firstName: 'Vorname',
      fee: 'TN Gebühr',
      vat: 'MwSt.',
      lineTotal: 'Gesamt'
    },
    pdfStatus: {
      legendTitle: 'Legende',
      pending: 'Gebucht, PDF noch nicht erstellt',
      failed: 'PDF-Erstellung fehlgeschlagen'
    },
    actions: {
      showSellerData: 'Organisationsdaten',
      moreOptions: 'Weitere Aktionen',
      discard: 'Löschen/Verwerfen',
      bookNow: 'Jetzt buchen',
      previous: 'Vorherige Rechnung',
      next: 'Nächste Rechnung',
      freeInvoice: 'Freie Rechnung',
      collectiveInvoice: 'Sammelrechnung',
      bgCollectiveInvoice: 'BG-Sammelrechnung',
      companyCollectiveInvoice: 'Firma-Sammelrechnung',
      cancelInvoice: 'Storno',
      interfaceExport: 'Schnittstellenexport'
    },
    eInvoiceCheck: {
      title: 'E-Rechnung unvollständig',
      intro: 'Für die E-Rechnung fehlen folgende Pflichtangaben:',
      hint: 'Bitte ergänzen Sie diese Angaben vor dem Buchen. Wird trotzdem gebucht, ist die E-Rechnung fehlerhaft und kann vom Rechnungsempfänger möglicherweise nicht verarbeitet werden.',
      bookAnyway: 'Trotzdem buchen'
    },
    bookConfirm: {
      title: 'Rechnung buchen',
      message: 'Sind Sie sicher, dass die Rechnung „{title}“ jetzt verbucht werden soll? Die Rechnungsnummer wird vergeben und die Rechnung kann danach nicht mehr bearbeitet werden.',
      faultyEInvoice: 'Achtung: Es fehlen Pflichtangaben, die E-Rechnung wird fehlerhaft erstellt.'
    },
    discard: {
      title: 'Rechnung löschen/verwerfen',
      messageDraft: 'Soll der Rechnungsentwurf „{title}“ endgültig gelöscht werden? Die Abrechnung der Teilnehmer wird zurückgesetzt.',
      messageLegacy: 'Soll die Rechnung „{title}“ verworfen werden? Sie wird storniert, offene Zahlungen werden entfernt und die Abrechnung der Teilnehmer wird zurückgesetzt.',
      deleted: 'Der Rechnungsentwurf wurde gelöscht.',
      cancelled: 'Die Rechnung wurde verworfen.',
      error: 'Die Rechnung konnte nicht gelöscht/verworfen werden.'
    },
    cancel: {
      title: 'Hinweis zu Stornierung',
      selected: '{count} Rechnung(en) ausgewählt:',
      confirm: 'Stornierung bitte jetzt bestätigen!',
      hint: 'Zu jeder Rechnung wird eine Gutschrift erstellt (PDF über „Drucken“); bezahlte Kurszahlungen werden storniert und gutgeschrieben, die Abrechnung der Teilnehmer wird zurückgesetzt.',
      action: 'Stornieren',
      noSelection: 'Selektieren Sie ein oder mehrere Rechnung(en), die nicht schon storniert sind!',
      freeCreditNote: 'Eine freie Gutschrift kann nicht storniert werden!',
      notCancellable: 'Diese Rechnung ist bereits storniert oder eine Gutschrift und kann nicht storniert werden.',
      success: '{count} Rechnung(en) storniert.',
      failed: '{number}: {message}',
      error: 'Die Rechnung konnte nicht storniert werden.'
    },
    archive: {
      title: {
        recent: 'Gebuchte Rechnungen der letzten 2 Jahre',
        older: 'Gebuchte Rechnungen älter als 2 Jahre'
      },
      mailStatus: {
        sent: 'ja',
        mails: 'Mail an:',
        mail: '{mail} ({name}) Gesendet: {datetime}',
        errors: 'Fehler beim Versand:',
        error: '{datetime} {error}'
      },
      csvNoSelection: 'Selektieren Sie eine oder mehrere Rechnungen!',
      csvError: 'Der CSV-Export ist fehlgeschlagen.',
      empty: 'Keine gebuchten Rechnungen vorhanden.',
      recreatePdf: 'PDF neu erstellen',
      pdfMissing: 'Das abgelegte PDF dieser Rechnung wurde nicht gefunden.',
      pdfMissingChooseTemplate: 'Das abgelegte PDF dieser Rechnung wurde nicht gefunden und die ursprüngliche Briefvorlage existiert nicht mehr.',
      pdfMissingDownload: 'Das abgelegte PDF dieser Rechnung wurde nicht gefunden. Bitte erstellen Sie es über „PDF neu erstellen“ neu.',
      downloadInvoice: 'Rechnung herunterladen',
      noPdf: 'Für diese Rechnung ist kein PDF abgelegt.',
      print: 'Drucken',
      notPrintableDiscarded: 'Verworfene Rechnungsdaten können nicht gedruckt werden.',
      mail: 'Mail senden',
      warnings: {
        recipient_deleted: 'Der Rechnungsempfänger ist nicht mehr vorhanden. Das Rechnungs-PDF wurde trotzdem in seiner Ablage gespeichert.'
      },
      letterDialog: {
        printTitle: 'Rechnung drucken',
        template: 'Briefvorlage',
        templatePreview: 'Briefvorlage / Vorschau',
        noTemplates: 'Für diese Rechnung ist keine passende Briefvorlage vorhanden.',
        attachment: 'Anhang',
        printAction: 'Drucken',
        filedPdf: 'Für diese Rechnung wurde bereits ein PDF erstellt: {filename} – erstellt am {created} von {user}. Es wird kein neues PDF erzeugt.',
        filedPdfWithoutUser: 'Für diese Rechnung wurde bereits ein PDF erstellt: {filename} – erstellt am {created}. Es wird kein neues PDF erzeugt.',
        originalTemplate: 'bisherige Vorlage',
        previewLoading: 'Vorschau wird geladen …',
        previewEmpty: 'Für diese Briefvorlage liegt keine Vorschau vor.',
        printed: 'Das Rechnungs-PDF wurde erstellt und abgelegt.',
        printError: 'Das Rechnungs-PDF konnte nicht erstellt werden.',
        mailAction: 'Senden',
        tabs: {
          template: 'Briefvorlage',
          preview: 'Vorschau'
        }
      },
      mailDialog: {
        title: 'Rechnung per Mail senden',
        runTitle: 'Rechnung {number} per Mail',
        queued: 'Der Mailversand wurde eingereiht.',
        sendError: 'Die Rechnung konnte nicht per Mail versendet werden.',
        previewEmpty: 'Für diese Auswahl liegt keine Vorschau vor.',
        subject: 'Betreff',
        variables: 'Variablen',
        mailTo: 'eMail an',
        name: 'Name',
        bcc: 'BCC',
        replyTo: 'reply to',
        invoiceAddress: 'Rechnungsadresse/Mail',
        notMailableBg: 'Rechnungen an eine Berufsgenossenschaft werden nicht per Mail versendet.',
        notMailableStorno: 'Stornierte Rechnungen werden nicht per Mail versendet.',
        pdfNotPrinted: 'Es kann keine PDF-Rechnung versendet werden, da die Rechnung noch nicht gedruckt wurde.',
        attachmentPdf: 'PDF-Rechnung',
        attachmentXml: 'E-Rechnung (XML)',
        attachmentPdfInfo: 'Die gedruckte PDF-Rechnung mit eingebetteter E-Rechnung (ZUGFeRD): lesbares PDF und maschinenlesbare XML-Daten in einer Datei.',
        attachmentXmlInfo: 'Nur die E-Rechnung als XML-Datei (XRechnung) zur automatischen Verarbeitung beim Empfänger, z. B. in dessen Buchhaltungssoftware. Sie enthält kein lesbares PDF und kann nur per Mail versendet werden.',
        fileName: 'Dateiname',
        tabs: {
          recipient: 'Empfänger',
          text: 'Mailtext',
          recipientText: 'Empfänger/Text'
        },
        vars: {
          recipientFirstName: 'Empfänger Vorname',
          recipientLastName: 'Empfänger Nachname',
          courseName: 'Kursname',
          courseNumber: 'Kursnummer',
          courseDate: 'Kursdatum',
          typedOrganisation: 'getypter Mandantname',
          invoiceNumber: 'Rechnungsnummer'
        }
      }
    },
    booking: {
      noSelection: 'Bitte wählen Sie in der Übersicht eine Rechnung aus.',
      noParticipants: 'Keine Teilnehmer vorhanden.',
      sumTotal: 'Summe gesamt',
      sections: {
        recipient: 'Empfänger',
        booking: 'Buchung',
        participantFees: 'Teilnehmer Gebühren',
        additionalItems: 'Zusatz-Posten',
        invoiceTotal: 'Rechnungsbetrag gesamt'
      },
      fields: {
        alternativeName: 'Name Rechnungsadresse',
        category: 'Kategorie',
        invoiceSum: 'Rechnungssumme'
      }
    },
    messages: {
      itemsSaveError: 'Die Posten konnten nicht gespeichert werden.',
      recipientSaveError: 'Der Rechnungsempfänger konnte nicht gespeichert werden.',
      notAvailable: 'Noch nicht verfügbar',
      downloadError: 'Das PDF konnte nicht heruntergeladen werden.',
      loadError: 'Daten konnten nicht geladen werden.',
      bookingError: 'Die Rechnung konnte nicht gebucht werden.',
      notFound: 'Die Rechnung wurde nicht gefunden.',
      conflict: 'Die Rechnung wird bereits gebucht oder ist schon gebucht.',
      invalidTemplate: 'Die gewählte Briefvorlage ist für diese Rechnung nicht zulässig.',
      booked: 'Rechnung {number} wurde erfolgreich erstellt',
      noFurtherInvoices: 'Es gibt keine weiteren nicht gebuchten Rechnungen.'
    }
  },
  lettersPanel: {
    additionalInformation: 'Zusatzinformation',
    pageTnTitle: 'Schein(e) je Teilnehmer',
    pageTnLabel: 'Anzahl Schein(e) je Teilnehmer',
    templatesPlaceholder: 'Die Vorlagenanbindung wird im nächsten Schritt ergänzt.',
    previewPlaceholder: 'Die Vorschau wird im nächsten Schritt ergänzt.',
    previewMissingSelectionTitle: 'Fehlende Auswahl',
    previewMissingTemplate: 'Bitte wählen Sie mindestens eine Vorlage aus.',
    previewMissingTeacher: 'Bitte wählen Sie mindestens eine Fachlehrkraft aus.',
    previewMissingParticipant: 'Bitte wählen Sie mindestens einen Teilnehmer aus.',
    tabTemplates: 'Vorlagen',
    tabBrief: 'Brief',
    tabTeachers: 'Dozenten mit Lehrschein für diesen Kurs',
    tabRecipients: 'Teilnehmer',
    tabPreview: 'Vorschau',
    previewSelectionTitle: 'Aktuelle Vorschauauswahl',
    previewTemplateLabel: 'Vorlage',
    previewTeachersLabel: 'Fachlehrkräfte',
    previewParticipantsLabel: 'Teilnehmer',
    previewTeachersLabelShort: 'Doz.',
    previewParticipantsLabelShort: 'TN',
    previewLoading: 'Vorschau wird geladen ...',
    previewNoDocuments: 'Für die Vorschau konnten keine Seiten erzeugt werden.',
    previewRefresh: 'Vorschau neu laden',
    previewPageLabel: 'Seite',
    previewPreviousPage: 'Vorherige Seite',
    previewNextPage: 'Nächste Seite',
    previewImageAlt: 'Vorlagenvorschau',
    previewImageUnavailable: 'Die Vorlagenvorschau konnte nicht geladen werden.',
    print: 'Drucken',
    sendMail: 'Als Mail versenden',
    previewTabIcon: 'Vorschau',
    previewDialogTitle: 'Vorschau',
    dispatchRecipients: 'Empfänger ({count})',
    reservationDispatchHint: 'Jede ausgewählte Firma erhält ihre eigene Reservierung mit eigenem Eintragungslink.',
    mixedReservationWarning: 'Reservierungen und Teilnehmer sind gemischt ausgewählt: Der Reservierungsbrief wird nur für die Reservierungen erstellt, alle anderen Briefe nur für die Teilnehmer.'
  },
  lettersMails: {
    tabLetters: 'Briefe',
    tabRecipients: 'Empfänger',
    tabAttachments: 'Anhänge',
    comingSoon: 'Diese Funktion kommt später.',
    recipients: {
      none: 'keine Empfänger',
      count: '{count} Empfänger',
      nameColumn: 'Name',
      empty: 'Wählen Sie in einer Kurs- oder Lehrkräfteliste Einträge aus und öffnen Sie Briefe & Mails.',
      remove: 'Empfänger entfernen',
      removeConfirmTitle: 'Empfänger entfernen',
      removeConfirm: 'Möchten Sie diesen Empfänger entfernen?',
      openCustomer: 'Zum Kunden wechseln',
      openCustomerTitle: 'Kundenansicht öffnen',
      openCustomerConfirm: 'Möchten Sie zum Kunden wechseln?',
      openTeacher: 'Zur Fachlehrkraft wechseln',
      openTeacherTitle: 'Fachlehrkraftansicht öffnen',
      openTeacherConfirm: 'Möchten Sie zur Fachlehrkraft wechseln?'
    },
    attachments: {
      none: 'keine Mailanhänge',
      one: '1 Mailanhang',
      count: '{count} Mailanhänge',
      empty: 'Es wurden noch keine Anhänge hinzugefügt.',
      add: 'Anhänge hinzufügen',
      remove: 'Anhang entfernen',
      hint: 'PDF-, PNG- und JPEG-Dateien; insgesamt höchstens 2 MB.',
      rejected: 'Mindestens eine Datei hat ein ungültiges Format oder überschreitet das Gesamtlimit von 2 MB.'
    },
    recipientTransfer: {
      title: 'Empfänger übernehmen',
      courseConfirm: '{count} Empfänger aus den ausgewählten Kursen in Briefe & Mails übernehmen?',
      teacherConfirm: '{count} ausgewählte Lehrkräfte in Briefe & Mails übernehmen?',
      clientConfirm: '{recipient} als Empfänger in Briefe & Mails übernehmen?',
      selectionConfirm: '{count} ausgewählte Empfänger in Briefe & Mails übernehmen?',
      noSelection: 'Bitte wählen Sie zuerst mindestens einen Eintrag aus.',
      noRecipients: 'Für die Auswahl wurden keine Empfänger gefunden.',
      confirm: 'Übernehmen'
    },
    recipientCollector: {
      title: 'Empfänger',
      widgetTooltip: 'Empfängerliste für die Briefe',
      addButtonTooltip: 'Zur Empfänger-Sammlung hinzufügen',
      addedOne: 'Zur Empfänger-Sammlung hinzugefügt.',
      addedMultiple: '{count} Empfänger zur Empfänger-Sammlung hinzugefügt.',
      alreadyAdded: 'Bereits in der Empfänger-Sammlung.',
      removeTooltip: 'Aus Sammlung entfernen',
      applyFromListTooltip: 'Aus Empfängerliste übernehmen',
      confirmDialogTitle: 'Empfänger-Sammlung übernehmen',
      confirmDialogMessage: 'Sie haben {count} Empfänger in Ihrer Sammlung. Möchten Sie diese zu den vorhandenen Brief-Empfängern hinzufügen oder die Brief-Empfänger komplett durch die Sammlung ersetzen?',
      confirmDialogAdd: 'Hinzufügen',
      confirmDialogReplace: 'Komplett übernehmen',
      confirmDialogDismiss: 'Abbrechen'
    },
    searchLabel: 'Vorlage suchen',
    searchScopeTooltip: 'Es werden nur Briefvorlagen für das Modul „{module}“ gesucht und angezeigt.',
    searchScopeModules: {
      kdb: 'KDB',
      fmv: 'FMV',
      ktv: 'Kurse',
      ls: 'Akademie',
      kifam: 'Familie'
    },
    backToTree: 'Zurück zum Baum',
    noSearchResults: 'Keine Treffer gefunden.',
    rename: 'Umbenennen',
    newFolder: 'Neuer Ordner',
    visibility: 'Freigaben',
    moveTo: 'Verschieben nach …',
    renameDialogTitle: 'Umbenennen',
    renameLabel: 'Name',
    renameSuccess: 'Die Umbenennung wurde gespeichert.',
    newFolderDialogTitle: 'Neuer Ordner',
    folderNameLabel: 'Name',
    folderDescriptionLabel: 'Beschreibung',
    newFolderSuccess: 'Der Ordner wurde angelegt.',
    visibilityDialogTitle: 'Freigaben',
    visibilityPrivate: 'Nur für mich',
    visibilityOrg: 'Für alle in meiner Organisation',
    visibilitySuccess: 'Die Freigabe wurde geändert.',
    deleteDialogTitle: 'Löschen',
    deleteConfirmFolder: 'Möchten Sie diesen Ordner wirklich löschen?',
    deleteConfirmLetter: 'Möchten Sie diesen Brief wirklich löschen?',
    deleteFolderNotEmptyWarning: 'Dieser Ordner ist nicht leer und wird noch von folgenden Modulen verwendet:',
    deleteFolderNotEmptyConfirm: 'Möchten Sie den Ordner trotzdem löschen?',
    deleteSuccess: 'Der Eintrag wurde gelöscht.',
    moveDialogTitle: 'Verschieben nach …',
    moveTargetHint: 'Wählen Sie einen Zielordner aus.',
    moveConfirmButton: 'Verschieben',
    moveSuccess: 'Der Eintrag wurde verschoben.',
    actionError: 'Die Aktion konnte nicht ausgeführt werden.',
    lastModifiedAt: 'Zuletzt bearbeitet am {date}',
    noDescription: '<keine Beschreibung>',
    derivedFrom: 'abgeleitet aus {name}',
    usesLayout: 'benutzt Layout "{layout}" mit {configType} Konfiguration',
    letterSpecificConfig: 'briefspezifischer',
    defaultConfig: 'default',
    emptyEditorPlaceholder: 'Wählen Sie links einen Brief aus.',
    readOnlyNotice: 'Diese Vorlage kann nicht bearbeitet werden.',
    customCopyBadge: 'Ableitung',
    savedAsCopyNotice: 'Diese Vorlage wurde als eigene Kopie im Ordner "KV-Vorlagen" gespeichert.',
    saveSuccess: 'Der Brief wurde gespeichert.',
    previewUnsavedNotice: 'Die Vorschau zeigt den zuletzt gespeicherten Stand. Ungespeicherte Änderungen werden erst nach dem Speichern angezeigt.',
    sendNotAvailable: 'Der Versand ist erst verfügbar, sobald die Empfänger-Auswahl bereitsteht.',
    send: {
      dialogTitle: 'E-Mail versenden',
      recipientCount: 'Die E-Mail wird an {count} Empfänger versendet.',
      campaignLabel: 'Mit Kampagne erstellen (optional)',
      noRecipients: 'Es sind keine Empfänger ausgewählt.',
      mailToMe: 'Mail an mich',
      mailToMeDialogTitle: 'Mail an mich senden',
      mailToMeInfo: 'Die E-Mail des ersten Empfängers wird an Ihre eigene E-Mail-Adresse gesendet und nicht abgelegt.',
      donationReceiptHint: 'Hinweis: Zuwendungsbestätigungen bitte über die Jahresquittung erstellen. Hier erzeugte Dokumente werden als Kopie markiert.'
    },
    dispatch: {
      titleMail: 'E-Mail-Versand: {name}',
      titlePrint: 'PDF-Erstellung: {name}',
      queued: 'Der Auftrag wurde gestartet. Fortschritt und Ergebnis finden Sie unter "Nachrichten".'
    },
    print: {
      dialogTitle: 'PDF erstellen',
      filenameLabel: 'Dateiname',
      defaultFilename: 'Brief'
    },
    variablesButton: 'Variablen',
    widgetConfigSaved: 'Die Widget-Konfiguration wurde gespeichert.',
    saveAsTemplate: {
      dialogTitle: 'Vorlage speichern',
      hint: "Bitte geben Sie den Namen an, unter der die Vorlage in 'Eigene Vorlagen' gespeichert werden soll.",
      nameLabel: 'Name',
      modulesLabel: 'Module',
      visibilityLabel: 'Freigabe',
      descriptionLabel: 'Beschreibung',
      moduleLabels: {
        kdb: 'Kunden',
        fmv: 'Fördermitglieder',
        ktv: 'Kurse',
        ls: 'Akademie',
        kifam: 'Familie'
      }
    },
    saveOverwriteConfirm: {
      dialogTitle: 'Vorlage speichern',
      message: "Änderung der Vorlage übernehmen, oder neue Vorlage in 'Eigene Vorlagen' speichern?",
      applyButton: 'Übernehmen',
      newTemplateButton: 'Neue Vorlage',
      cancelButton: 'Abbrechen'
    },
    widget: {
      tnList: {
        title: 'Widget: Teilnehmerliste',
        columnName: 'Spaltenname',
        order: 'Reihenfolge',
        moveUp: 'Nach oben verschieben',
        moveDown: 'Nach unten verschieben',
        minList: 'Mindestanzahl',
        addList: 'Angehängte Zeilen'
      },
      uwtBank: {
        title: 'Widget: Überweisungsträger',
        receiptPosition: 'Belegposition',
        fillOut: 'Angaben ausfüllen',
        fillPayment: 'Betrag ausfüllen',
        fillRngNumber: 'Belegnummer ausfüllen',
        left: 'Links',
        right: 'Rechts',
        yes: 'Ja',
        no: 'Nein'
      },
      barcode: {
        title: 'Widget: Barcode',
        typeLabel: 'Barcode-Typ',
        type39: 'Typ 39',
        type128: 'Typ 128'
      },
      stamp: {
        title: 'Widget: Stempel',
        uploadLabel: 'Bild auswählen',
        height: 'Höhe (mm)',
        width: 'Breite (mm)',
        leftOffset: 'Links-/Rechts-Versatz (mm)',
        topOffset: 'Oben-/Unten-Versatz (mm)'
      },
      invoiceSummary: {
        title: 'Widget: MwSt-Übersicht',
        showFreeText: '§ 4 Hinweis anzeigen (nur bei ausschließlich 0% MwSt.)'
      },
      fmvContribution: {
        title: 'Widget: Zuwendungsliste',
        refundLabel: 'Verzicht auf Erstattung von Aufwendungen',
        refundYes: 'Ja',
        refundNo: 'Nein',
        addPageLabel: 'Anhangsverhalten',
        addPageAlways: 'Anhang immer',
        addPageNoneOnSingle: 'Kein Anhang bei einmaliger Zahlung pro Jahr',
        addPageBlankOnSingle: 'Anhang als Leerseite einfügen bei einmaliger Zahlung pro Jahr'
      },
      membercard: {
        title: 'Widget: Mitgliedsausweis',
        airService: 'Tel.nr. Flugdienst anzeigen',
        ovName: 'OV-Name anzeigen'
      },
      emailSignature: {
        title: 'Widget: E-Mail-Signatur',
        sourceLabel: 'Absender-Quelle',
        sourceUser: 'Benutzer',
        sourceBvw: 'BVW',
        sourceDldb: 'DLDB',
        sourceManual: 'Manuell',
        // KDB-2194: renamed "Ansprechpartner" to "Ansprechperson"
        bvwUserLabel: 'BVW-Ansprechperson',
        collectiveAddress: 'Sammelmail',
        manualSection: {
          name: 'Name',
          function: 'Funktion',
          level: 'Ebene',
          organisation: 'Organisation',
          street: 'Straße',
          city: 'PLZ, Ort',
          phone: 'Telefon',
          fax: 'Fax',
          email: 'E-Mail'
        }
      }
    },
    moreOptions: {
      button: 'Weitere Optionen',
      layouts: 'Layouts',
      emailEditor: 'E-Mail-Editor'
    },
    layout: {
      dialogTitle: 'Layout',
      nameColumn: 'Name',
      descriptionColumn: 'Beschreibung',
      configuratorTitle: 'Konfigurator',
      settingColumn: 'Einstellung',
      valueColumn: 'Wert',
      useDefaultToggle: 'Standardkonfiguration des Layouts verwenden',
      applyBtn: 'Übernehmen',
      previewBtn: 'Vorschau',
      saveSuccess: 'Das Layout wurde übernommen.',
      lastModifiedAt: 'Zuletzt geändert am {date}',
      pageNumber: {
        title: 'Seitenzahl',
        label: 'Seitenzahl anzeigen'
      },
      header: {
        title: 'Ränder (ab 2. Seite)',
        firstPageOnly: 'schmale Ränder (kein Logo)',
        smallOnOtherPages: 'kleinerer Rand oben (zeigt ggf. Logo)'
      },
      barcode: {
        title: 'Barcode',
        show: 'im Footer anzeigen',
        typeLabel: 'Typ',
        type39: 'Typ 39',
        type128: 'Typ 128'
      },
      logo: {
        title: 'Logo(s)',
        visible: 'anzeigen',
        fromPage: 'je/ab Seite',
        fromPageTip: 'je Seite = 1,3,4 (Komma getrennt) — ab Seite = 2- (Zahl, Bindestrich) — von-bis Seite = 2-3',
        rightVariant: 'Logo rechts',
        rightUpload: 'Logo rechts hochladen',
        leftShow: 'Logo links anzeigen',
        leftUpload: 'Logo links hochladen',
        automatic: 'automatisch (DRK/BRK)',
        uploadOption: 'Upload'
      },
      jrkHeaderText: {
        title: 'JRK Header Text',
        label: 'Header Text'
      }
    },
    email: {
      dialogTitle: 'E-Mail-Editor',
      subjectLabel: 'Betreff',
      previewBtn: 'Vorschau',
      saveBtn: 'Speichern',
      saveSuccess: 'Die E-Mail-Vorlage wurde gespeichert.'
    }
  },
  courseTermine: {
    headerGroups: {
      termin: 'Termin',
      dozenten: 'Fachlehrkraft',
      kursort: 'Kursort'
    },
    format: {
      presence: 'Präsenz',
      hybrid: 'Hybrid',
      online: 'Online'
    },
    venueType: {
      kv: 'Kurs in KV',
      online: 'online (KV-Adresse)',
      firmaClosed: 'Kurs für Firma (geschlossen)',
      firmaExternal: 'Kurs in Firma'
    },
    bulk: {
      menuLabel: 'Stapelverarbeitung',
      changeRoom: 'Kursraum ändern',
      changeTeacher: 'Dozent ändern',
      changeVenue: 'Veranstaltungsort ändern',
      appliesToCount: 'Wird auf {count} ausgewählte Termine angewendet'
    },
    columns: {
      date: 'Datum',
      day: 'Tag',
      from: 'von',
      to: 'bis',
      format: 'Terminformat',
      teacherName: 'Dozent/Name',
      venue: 'Veranstaltungsort',
      site: 'Standort',
      street: 'Straße',
      zip: 'PLZ',
      city: 'Ort',
      room: 'Kursraum'
    },
    dialog: {
      addTitle: 'Termin',
      editTitle: 'Termin bearbeiten',
      seriesTitle: 'Terminserie anlegen',
      singleDate: 'Datum',
      timeStart: 'Kursbeginn Uhrzeit',
      timeEnd: 'Kursende Uhrzeit',
      venueKv: 'Kurs in KV',
      venueOnlineKv: 'online (KV-Adresse)',
      venueCompanyClosed: 'Kurs für Firma (geschlossen)',
      venueCompanyExternal: 'Kurs in Firma',
      dateStart: 'Startdatum',
      dateEnd: 'Endet am Datum',
      endCount: 'Endet nach Terminen',
      frequency: 'Häufigkeit',
      intervalCount: 'Alle / aller (Anzahl)',
      weekday: 'Wochentage',
      seriesHint: 'Alle Termine der Serie sind Einzeleinträge in der Tabellenansicht. Zunächst ist in der Serie für alle der gleiche Dozent und der gleiche Ort hinterlegt. Durch Bearbeitung eines Einzeltermins können diese geändert werden.'
    },
    confirm: {
      deleteTitle: 'Termin löschen',
      deleteMessage: 'Möchten Sie die ausgewählten Termine wirklich löschen? | Möchten Sie diesen Termin wirklich löschen? | Möchten Sie diese {count} Termine wirklich löschen?'
    }
  },
  courseTerminWizard: {
    title: 'Termine anlegen',
    step_termine: 'Termine',
    step_zuordnung: 'Zuordnung',
    step_summary: 'Prüfen',
    toolbar: {
      addSingle: 'Einzeltermin hinzufügen',
      addSeries: 'Terminserie hinzufügen'
    },
    table: {
      count: '{count} Termine',
      empty: 'Noch keine Termine. Fügen Sie einen Einzeltermin oder eine Terminserie hinzu.',
      teacherPlaceholder: 'Dozent wählen'
    },
    mass: {
      title: 'Sammelzuweisung',
      hint: 'Setzen Sie Veranstaltungsort, Raum, Dozent oder Format für mehrere Termine auf einmal. Markieren Sie Zeilen, um nur diese zu ändern.',
      apply: 'Übernehmen',
      scopeAll: 'Auf alle {count} Termine',
      scopeSelected: 'Auf {count} ausgewählte'
    },
    series: {
      title: 'Terminserie hinzufügen'
    },
    datum: {
      startDate: 'Startdatum',
      endDate: 'Endet am Datum',
      endCount: 'Endet nach Terminen',
      every: 'Alle',
      weekdays: 'Wochentage'
    },
    unit: {
      days: 'Tage',
      weeks: 'Wochen',
      months: 'Monate'
    },
    weekday: {
      mon: 'Mo',
      tue: 'Di',
      wed: 'Mi',
      thu: 'Do',
      fri: 'Fr',
      sat: 'Sa',
      sun: 'So'
    },
    summary: {
      overview: 'Übersicht',
      dateCount: 'Anzahl Termine'
    },
    confirm_title: 'Termine speichern',
    confirm_message: 'Möchten Sie {count} Termine anlegen?',
    saved_success: 'Termine angelegt',
    saved_error: 'Fehler beim Anlegen der Termine',
    validation: {
      required: 'Bitte füllen Sie die Pflichtfelder aus.',
      dateRequired: 'Bitte für alle Termine ein gültiges Datum angeben.',
      timeRequired: 'Bitte für alle Termine Beginn- und Endzeit (HH:MM) angeben.',
      endRequired: 'Bitte ein Enddatum oder eine Anzahl angeben.',
      noDates: 'Aus den Angaben konnten keine Termine erzeugt werden.',
      noCourse: 'Kein Kurs geladen.'
    }
  },
  marketingTool: {
    companies: {
      title: 'Firmen',
      search: 'Suche',
      empty: 'Keine Firmen gefunden',
      needsRefresh: 'Auffrischung notwendig',
      noRefresh: 'Keine Auffrischung notwendig'
    },
    company: {
      title: 'Firmendetail',
      none: 'Keine Firma ausgewählt',
      addressee: 'Ansprechpartner',
      addresseeCompany: 'Firma',
      mainContact: 'Hauptansprechpartner',
      fields: {
        firma: 'Firma',
        firma2: 'Firma 2',
        street: 'Straße',
        zip: 'PLZ',
        city: 'Ort',
        phone: 'Telefon',
        mobile: 'Mobil',
        email: 'E-Mail',
        fax: 'Fax',
        bgNumber: 'Unternehmensnr.',
        payers: 'zust. BG',
        vatNumber: 'USt-ID',
        taxNumber: 'Steuernr.',
        costCenter: 'Kostenstelle',
        debKonto: 'Debitorenkonto'
      }
    },
    filters: {
      status: 'Status',
      statusAll: 'alle',
      statusGreen: 'Grün',
      statusYellowRed: 'Gelb/Rot',
      statusBlack: 'Schwarz',
      course: 'Kurs'
    },
    colors: {
      black: 'Schwarz',
      red: 'Rot',
      yellow: 'Gelb',
      green: 'Grün'
    },
    legend: {
      title: 'Legende',
      green: '0–12 Monate',
      yellow: '13–19 Monate',
      red: '20–24 Monate',
      black: 'ab 25 Monate'
    },
    candidates: {
      title: 'Teilnehmer',
      name: 'Name',
      course: 'Kurs',
      firstDate: 'erster Kurstag',
      lastDate: 'letzter Kurstag',
      empty: 'Keine Teilnehmer gefunden',
      external: 'Anmeldung über das Firmenportal',
      selected: '{count} ausgewählt',
      letterTooltip: 'Erinnerungsbrief: {name} / Datum: {date}'
    },
    letters: {
      title: 'Brief',
      slot: 'Brief {slot}',
      change: 'Brief ändern',
      changeTitle: 'Brief {slot} ändern',
      template: 'Briefvorlage',
      save: 'Speichern',
      saveError: 'Der Brief konnte nicht gespeichert werden.'
    },
    freeText: 'Zusatzinformation',
    preview: {
      title: 'Vorschau',
      loading: 'Vorschau wird geladen …',
      empty: 'Keine Vorschau vorhanden',
      selectParticipants: 'Bitte Teilnehmer auswählen, um die Vorschau anzuzeigen.',
      page: 'Seite {current} von {total}',
      error: 'Die Vorschau konnte nicht geladen werden.'
    },
    dispatch: {
      refreshPreview: 'Vorschau aktualisieren',
      letterToMe: 'Brief an mich',
      notStoredHint: 'Dokumente werden erzeugt, aber nirgends hinterlegt oder verknüpft.',
      filename: 'Marketingbrief.pdf',
      cancel: 'Abbrechen',
      error: 'Der Auftrag konnte nicht gestartet werden.',
      mailToMe: {
        button: 'Mail an mich',
        title: 'Mail an mich senden',
        confirm: 'Die E-Mail mit dem Brief „{letter}“ an {addressee} ({count} Teilnehmer) wird an Ihre eigene E-Mail-Adresse gesendet und nicht abgelegt.',
        action: 'Senden'
      },
      mail: {
        button: 'Mail(s) senden',
        title: 'Mail(s) senden',
        confirm: 'Der Brief „{letter}“ wird per E-Mail an {addressee} gesendet ({count} Teilnehmer). Der Erinnerungsbrief wird bei den Teilnehmern vermerkt.',
        action: 'Senden'
      },
      print: {
        button: 'Brief(e) drucken',
        title: 'Brief(e) drucken',
        confirm: 'Der Brief „{letter}“ an {addressee} wird als PDF erstellt ({count} Teilnehmer). Der Erinnerungsbrief wird bei den Teilnehmern vermerkt.',
        action: 'Drucken'
      }
    },
    messages: {
      loadError: 'Die Daten des Marketingtools konnten nicht geladen werden.'
    }
  }
}
